/* eslint-disable */
// import jwtInterceptor from "../Shared/jwtInterceptor";
import axios from "axios";
import baseinput from "./form_elements/baseinput";
import basedate from "./form_elements/basedate";
import basedatetime from "./form_elements/basedatetime";
import basenumber from "./form_elements/basenumber";
import baseselect from "./form_elements/baseselect";
import basecheckbox from "./form_elements/basecheckbox";
import baseradiogroup from "./form_elements/baseradiogroup"
import * as formService from "./dynamicformservice";
import digitalFormModal from "../../components/digital_form_modal/digital_form_modal.vue"
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import QRCode from 'qrcode'
import { isConstructorDeclaration, isThrowStatement, visitParameterList } from "typescript";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import ValidationMessage from "./errormessages.vue";
import basetime from "./form_elements/basetime.vue";
import Multiselect from "@vueform/multiselect";

const idtoken = store.getters.getIdToken;
export default {
  name: "newtemplate",
  props: {
    isPatientVisit: {
      type: Boolean,
      default: false
    },
    templateid: {
      type: String,
      default: ''
    },
    stdyid: {
      type: String,
      default: ''
    },
    visitids: {
      type: String,
      default: ''
    },
    subjectid: {
      type: String,
      default: ''
    },
    siteid: {
      type: String,
      default: ''
    },
    skipcheckingdependency: {
      type: Boolean,
      default: false
    },
    issavefun: {
      type: Boolean,
      default: false
    },
    requiredvalidate: {
      type: Boolean,
      default: true
    },
    requiredsubmit: {
      type: Boolean,
      default: true
    },
    requiredlanguage: {
      type: Boolean,
      default: true
    },
    requiredrole: {
      type: Boolean,
      default: false
    },
    fromUrlStatus: {
      type: Boolean,
      default: false
    },
    isSigned: {
      type: Boolean,
      default: false
    },
    isnewLink: {
      type: Boolean,
      default: false
    },
    templateName: {
      type: String,
      default: ''
    },
    templatebasedon: {
      type: String,
      default: 'category'
    },
    requirednewform: {
      type: Boolean,
      default: false
    },
    autofillfromeconsent: {
      type: Boolean,
      default: false
    },
    icfid: {
      type: String,
      default: ''
    },
    scheduledvisit: {
      type: Object,
      default: () => ({})
    },
    previousRoute: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    baseinput,
    QRCode,
    baseselect,
    basecheckbox,
    baseradiogroup,
    basedate,
    basenumber,
    basedatetime,
    digitalFormModal,
    VPagination,
    CreateVideoCallSchedulePopUp,
    ValidationMessage,
    basetime,
    Multiselect
  },
  data() {
    return {
      isSaving: false,
      localScheduledVisit: {},
      commonvalidations: {},
      isreviewandsubmitbtn: false,
      isnextfunbtn: false,
      permissions: [],
      isvalidate: true,
      BlankForm: "BlankForm",
      CreateVideoCallSchedulePopUp: false,
      CurrentPatientID: "",
      autofield: [
        {
          "site_sub_autofill": [
            {
              "autofill": true,
              "labelsubject": "",
              "labelsite": ""
            }
          ]
        }
      ],
      encodedFormList: null,
      patientsId: "",
      sitesId: "",
      nextPageClick: false,
      repeatedgroupgroupnos: {},
      isrepeatdatavalid: {},
      selectedFormData: {},
      isrepeatvalid: {},
      calcfunvar: {},
      repeathidden: false,
      bothButtonDisabled: false,
      shouldContinue: true,
      repeatedpageno: "",
      repeatedfieldname: "",
      selectedrepeatedgroupno: 1,
      repeatedmeasurepopup: false,
      repeatedmeasurelistpopup: true,
      repeatedoptions: "",
      repeatedmeasurevalarray: [],
      temprepeatedmeasureval: {},
      repratmeasureid: new Date(),
      calculatedresult: {},
      previouscalculatedresult: {},
      currentgrid: [],
      gridoptarray: {},
      gridlinkeddatas: {},
      griddata: [
        {
          Rows: [""],
          Columns: [""],
          Fieldtypes: ["text"],
          Fielddata: {},
          Fieldoptions: {}
        }
      ],
      fileid: "",
      filepageno: null,
      filefieldname: null,
      numberanddateval: {},
      repeatednumberanddateval: {},
      qrcodetxt: {},
      selectedprivilege: "",
      selectedfield: "",
      selectedrole: "",
      fieldprivilegepopup: false,
      visitname: "",
      islanenglish: 'hr',
      fullPage: true,
      laguageselected: "",
      templist: [],
      versionlist: "",
      sourceTemplateId: "",
      language: [],
      roles: [],
      selectedFormLanguage: "",
      selectedFormVersion: "",
      selectedLanguage: "",
      displayLanguage: false,
      showModal: false,
      groupNo: 0,
      newTempID: "",
      fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
      baseurl: process.env.VUE_APP_Service_URL,
      saveid: "",
      editData: "",
      visitno: "",
      iPaddress: "",
      groups: {},
      repeatGroups: {},
      errormsg: {},
      errorsort: {},
      formdata: {},
      sendData: {
        sheduleID: "",
        formId: "",
        templateId: "",
        language: [],
        code: "",
        studyId: "",
        folderId: "",
        siteId: "",
        subjectId: "",
        visitId: "",
        visitName: "",
        totalPages: 0,
        version: "",
        formStatus: "New",
        formName: "",
        isDeleted: false,
        pages: [],
        sourceID: "",
        dataSource: "Web Browser"
      },
      errorclasslist: {},
      requiredclasslist: {},
      isvalid: [],
      bindarray: {
        page1: { siteCode: "test value", subjectNo: "" },
        page2: "",
        page3: "",
      },
      pageno: 1,
      totalpages: 0,
      initValue: 1,
      uploads: ["photo", "signature", "file"],
      inputElements: [
        "color",
        "email",
        "file",
        "hidden",
        "month",
        "number",
        "password",
        "range",
        "search",
        "tel",
        "text",
        "url",
        "week",
        "boxed",
        "textbox",
      ],
      htmlarray: [],
      sampledata: "",
      visitdetailsCache: {},
      frompatid: "",
      messagetype: {},
      pendingFieldValidationPromises: [],
      fileInputFocused: false,
      editcheckvar: {},
      calculatedfields: [],
      computedFieldEditability: {},
      visibility: {},
      subjectidforsend: "",
      templatenameforeditcheck: "",
      checkcustomeditcheckobject: {},
      domain: "",
      formList: [],
      LinkFieldList: [],
      eConsentAutofillStudyData: null,
      eConsentAutofillICFData: null,
      eConsentAutofillKey: "",
      isEConsentAutofillLoading: false,
      icfsiteid: "",
      icfsubjectid: "",
      eConsentDisabledFields: [
        "STUDYID",
        "STUDY_TITLE",
        "SPONSOR",
        "SUBJID",
        "SITEID",
        "ICFTITLE",
        "ICFVER",
        "ICFVER_DATE",
        "ICF_LANG",
        "IRB_APR_DATE",
        "IRD_EXP_DATE",
        "IRB_REF_NO"
      ],
      siteList: [],
      selectedSiteId: "",
      subjectList: [],
      selectedSubjectId: "",
      isSubjectForm: false,
    };
  },
  computed: {
    currentTemplateLanguageCode() {
      return (this.htmlarray?.[0]?.languageCode || this.islanenglish || "")
        .toString()
        .trim();
    },
    currentTemplateLanguageName() {
      return (this.htmlarray?.[0]?.language || this.laguageselected?.language || "")
        .toString()
        .trim()
        .toLowerCase();
    },
    isRtlLanguage() {
      const languageCode = this.currentTemplateLanguageCode.toLowerCase();
      const baseLanguageCode = languageCode.split(/[-_]/)[0];
      const rtlLanguageCodes = [
        "ar",
        "arc",
        "ckb",
        "dv",
        "fa",
        "ha",
        "he",
        "iw",
        "ks",
        "ku",
        "ps",
        "sd",
        "ug",
        "ur",
        "yi"
      ];
      const rtlLanguageNames = [
        "arabic",
        "aramaic",
        "divehi",
        "farsi",
        "hebrew",
        "kurdish",
        "persian",
        "pashto",
        "sindhi",
        "urdu",
        "uyghur",
        "yiddish"
      ];

      return rtlLanguageCodes.includes(baseLanguageCode) ||
        rtlLanguageNames.includes(this.currentTemplateLanguageName);
    },
    showStudyFormSelectors() {
      return (
        this.previousRoute?.name === "DataEntry" &&
        store.getters.getautofillenabled !== "true"
      );
    }
  },
  async mounted() {
    console.log("previousRoute =", this.previousRoute);
  console.log("previousRoute.name =", this.previousRoute?.name);
  console.log("autofill =", store.getters.getautofillenabled);
  console.log("showStudyFormSelectors =", this.showStudyFormSelectors);
    this.localScheduledVisit = JSON.parse(JSON.stringify(this.scheduledvisit));
    this.selectedFormLanguage = this.templateid
    this.selectedFormVersion = this.templateid
    this.isSubjectForm = localStorage.getItem("isSubjectForm");
    localStorage.removeItem("isSubjectForm");
    this.getsites();
    this.getpermission(this.templateid);
    this.getbyidforautofill();
    this.CurrentPatientID = localStorage.getItem("patid"); 
  },
  async unmounted() {
    await store.dispatch("setautofillsiteid", null);
    await store.dispatch("setautofillsubjectid", null);
    await store.dispatch("setfrompatientschedule", null);
    let tempvar = {
      "Siteid": null,
      "Subject_id": null,
      "Visitname": null,
      "Visitno": null,
      "sheduleId": null
    }
    await store.dispatch("commitvisitdetails", tempvar);
  },

  async beforeMount() {
    await this.retrievevisitinfo();
    this.encodedFormList = this.$route.query.tempObj;
    console.log("encodedFormList", this.encodedFormList);
    if (this.encodedFormList != undefined) {
      const decodedFormList = JSON.parse(decodeURIComponent(this.encodedFormList));
      this.selectedFormData = decodedFormList
    }
    if (this.isnewLink === true) {
      await this.getTemplate()
    }
    else {
      if (this.templatebasedon == "general") {
        await this.getformtemplategeneral();
      }
      else {
        await this.getformtemplate();
      }
    }
    await this.loadComputedFieldsOnFormLoad();
    await this.getuserIp();
    await this.languagelist();
    await this.getallroles()
    await this.getuserIp();
  },
  methods:
  {
    async getpermission(templateid) {
      let userrole = await store.getters.getRolesData;
      const token = store.getters.getIdToken;
      const studyId = await store.getters.getStudyIs;
      const params = { studyId: studyId };

      try {
        const { data } = await axios.get(
          `${this.baseurl}/forms/formsprivilege/getprivileges?roleId=${userrole}&tempId=${templateid}`,
          { headers: { Authorization: `Bearer ${token}` }, params }
        );

        this.permissions = data[0].privileges;
        this.templatenameforeditcheck = data[0].templateName;
        this.getcheckcustomeditcheck();
        console.log("formPrivilegeItems", this.permissions);


      } catch (err) {
        console.error("Error fetching privileges:", err);
      }
    },
    async getsites() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/site/getallsitesbyuser?studyId=${currentstudyid}&getAll=false&sortProperty=siteCode&IsDes=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.siteList = res.data;
          console.log("Sites are", this.sites)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getSubjects() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      if (!this.selectedSiteId || this.selectedSiteId === 'All') {
        this.subjectList = [];
        this.selectedSubjectId = 'All';
        return;
      }
      await axios
        .get(
          `${this.baseurl}/management/patient/listpatient?SiteId=${this.selectedSiteId}&Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
           this.subjectList = res.data.results;
           this.selectedSubjectId = "";  
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async onSubjectChange() {

      const selectedSubject = this.subjectList.find(
        x => x.patientId === this.selectedSubjectId
      );

      // Store GUID
      this.sendData.subjectId = this.selectedSubjectId;

      if (!selectedSubject || !this.htmlarray.length) {
        return;
      }

      this.htmlarray[0].pages.forEach(page => {

        page.field.forEach(field => {

          if (
            field.fieldName ===
            this.autofield[0].site_sub_autofill[0].labelsubject
          ) {

            // Form displays Subject ID
            this.formdata[`pageNo${page.pageNo}`][field.fieldName] =
              selectedSubject.subjectId;

          }

        });

      });

    },
    async onSiteChange() {

      await this.getSubjects();

      this.selectedSubjectId = "";
      this.sendData.subjectId = "";

      // Store GUID
      this.sendData.siteId = this.selectedSiteId;

      const selectedSite = this.siteList.find(
        x => x.siteID === this.selectedSiteId
      );

      if (!selectedSite || !this.htmlarray.length) {
        return;
      }

      this.htmlarray[0].pages.forEach(page => {

        page.field.forEach(field => {

          if (
            field.fieldName ===
            this.autofield[0].site_sub_autofill[0].labelsite
          ) {

            // Form displays Site Name
            this.formdata[`pageNo${page.pageNo}`][field.fieldName] =
              selectedSite.siteName;

          }

        });

      });

    },
    gettimeformat(validation) {
      if (!Array.isArray(validation) || validation.length === 0) {
        return 'h:mm A'; // Default value when array is empty
      }

      // Find the element that starts with "DATEFORMAT"
      const timeFormatElement = validation.find((item) => item.startsWith("TIMEFORMAT"));

      if (timeFormatElement) {
        // Extract the string between parentheses
        const match = timeFormatElement.match(/\(([^)]+)\)/); // Regular expression to capture text inside parentheses
        return match ? match[1] : 'h:mm A'; // Return the captured group or default
      }

      return 'h:mm A'; // Default value when no matching element is found
    },
    getdateformat(validation) {
      if (!Array.isArray(validation) || validation.length === 0) {
        return 'DD-MM-YYYY'; // Default value when array is empty
      }

      // Find the element that starts with "DATEFORMAT"
      const dateFormatElement = validation.find((item) => item.startsWith("DATEFORMAT"));

      if (dateFormatElement) {
        // Extract the string between parentheses
        const match = dateFormatElement.match(/\(([^)]+)\)/); // Regular expression to capture text inside parentheses
        return match ? match[1].replace(/[a-z]/g, char => char.toUpperCase()) : 'MM-DD-YYYY'; // Return the captured group or default
      }

      return 'DD-MM-YYYY'; // Default value when no matching element is found
    },
    onFileInputFocus(fieldName) {
      this.fileInputFocused = true;
    },
    onFileInputBlur(pageNo, fieldName, validations) {
      // Only trigger this if there was a focus previously, meaning the user opened the dialog
      if (this.fileInputFocused) {
        this.focusOutFunctionForFileUpload(pageNo, fieldName, validations);
      }
    },
    focusOutFunctionForFileUpload(pageNo, fieldName, validations) {
      this.errormsg[fieldName] = "";
      this.messagetype[fieldName] = "";
      if (validations.includes("Required") || validations.includes("REQUIRED")) {
        if (this.formdata[`pageNo${pageNo}`][fieldName] == "" || this.formdata[`pageNo${pageNo}`][fieldName] == null) {
          this.errormsg[fieldName] = "Please upload a file to proceed.";
          this.messagetype[fieldName] = "Error"
        }
      }
    },
    numberanddateblurfun(pageNo, fieldName) {
      const numbdata = this.numberanddateval[fieldName].numberdata;
      const datedata = this.numberanddateval[fieldName].datedata;
      this.formdata[`pageNo${pageNo}`][fieldName] = this.formatDateNum(datedata) + "_" + numbdata;
      this.focusOutFunction(pageNo, fieldName, '');
    },
    async getrepeatedValueByKey(key, fieldname, identifier) {
      for (const page in this.formdata) {
        if (this.formdata[page].hasOwnProperty(fieldname)) {
          console.log("formdata", this.formdata);
          return this.formdata[page][fieldname][identifier][key];
        }
      }
      return null; // Return null if the key is not found
    },
    async getValueByKey(key) {
      for (const page in this.formdata) {
        if (this.formdata[page].hasOwnProperty(key)) {
          return this.formdata[page][key];
        }
      }
      return null; // Return null if the key is not found
    },
    getFormDataForEditCheckValidation() {
      if (!this.htmlarray || !this.htmlarray[0] || !Array.isArray(this.htmlarray[0].pages)) {
        return this.sendData;
      }

      const storevisitdetails = store.getters.getvisitdetails;
      const parsedstorevisitdetails =
        typeof storevisitdetails === "string"
          ? JSON.parse(storevisitdetails || "{}")
          : (storevisitdetails || {});
      const localvisitdetails = JSON.parse(localStorage.getItem("visitdetails") || "{}");
      const visitdetails =
        (this.visitdetailsCache && Object.keys(this.visitdetailsCache).length > 0)
          ? this.visitdetailsCache
          : (Object.keys(parsedstorevisitdetails).length > 0 ? parsedstorevisitdetails : localvisitdetails);
      const isfrompatientschedule = store.getters.getfrompatientschedule;

      this.sendData.totalPages = this.htmlarray[0].totalPages;
      this.sendData.templateId = this.htmlarray[0].templateId;
      this.sendData.studyId = this.stdyid || store.getters.getStudyIs;
      this.sendData.folderId = this.htmlarray[0].folderId ? this.htmlarray[0].folderId : "";
      this.sendData.sheduleID = isfrompatientschedule == "frompatientschedule"
        ? ""
        : (this.htmlarray[0].sheduleID ? this.htmlarray[0].sheduleID : (visitdetails.sheduleId ? visitdetails.sheduleId : this.sendData.sheduleID));
      this.sendData.visitNo = isfrompatientschedule == "frompatientschedule" ? this.selectedFormData.Visitno : this.visitno;
   
      const isStudyForms =
        this.previousRoute?.name === "DataEntry" &&
        store.getters.getautofillenabled !== "true";

      if (isStudyForms) {

        this.sendData.siteId = this.selectedSiteId || "";
        this.sendData.subjectId = this.selectedSubjectId || "";
      }
      else {

        this.sendData.siteId = isfrompatientschedule == "frompatientschedule"
          ? (this.selectedFormData.Siteid || this.sendData.siteId || this.siteid || "")
          : (visitdetails && visitdetails.Siteid
            ? visitdetails.Siteid
            : (this.sendData.siteId || this.siteid || ""));

        this.sendData.subjectId = isfrompatientschedule == "frompatientschedule"
          ? this.selectedFormData.Subject_id
          : (visitdetails && visitdetails.Subject_id
            ? visitdetails.Subject_id
            : (this.sendData.subjectId || this.subjectid || ""));

      }
      
      this.sendData.sourceID = this.iPaddress;
      this.sendData.dataSource = "Web Browser";
      this.sendData.formName = isfrompatientschedule == "frompatientschedule" ? this.selectedFormData.Template_name : this.htmlarray[0].templateName;
      this.sendData.visitId =
        this.visitids && this.visitids.trim() !== "0" ? this.visitids : "";
      this.sendData.version = this.htmlarray[0].version;
      this.sendData.visitName = isfrompatientschedule == "frompatientschedule" ? this.selectedFormData.Visitname : this.visitname;
      this.sendData.pages = this.htmlarray[0].pages.map((page) => this.buildEditCheckValidationPage(page));

      return this.sendData;
    },
    getEditCheckCheckboxValue(value) {
      return value === true || String(value).toLowerCase() === "true"
        ? "true"
        : "false";
    },
    getPayloadFieldVisibility(fieldName, fieldIdentifier, fallbackVisibility = true) {
      const visibility = this.visibility || {};
      const repeatedKey = fieldIdentifier === undefined || fieldIdentifier === null
        ? ""
        : `${fieldName}${fieldIdentifier}`;
      let liveVisibility;

      if (repeatedKey && Object.prototype.hasOwnProperty.call(visibility, repeatedKey)) {
        liveVisibility = visibility[repeatedKey];
      } else if (Object.prototype.hasOwnProperty.call(visibility, fieldName)) {
        liveVisibility = visibility[fieldName];
      } else {
        liveVisibility = fallbackVisibility;
      }

      return liveVisibility !== false && liveVisibility !== "false";
    },
    buildEditCheckValidationPage(page) {
      const pageData = this.formdata[`pageNo${page.pageNo}`] || {};
      const createdpage = {
        pageName: page.pageName,
        pageNo: page.pageNo,
        pageStatus: page.status,
        field: []
      };
      const repeatedfieldsavearray = {};

      (page.field || []).forEach((subitem) => {
        let val;
        let itemstatus;

        if (subitem.type == "checkbox") {
          val = this.getEditCheckCheckboxValue(pageData[subitem.fieldName]);
          itemstatus = "Not Validated";
        }
        else if (subitem.type === "RepeatingMeasure" || subitem.type === "repeatingfield" || subitem.type === "repeatedmeasure") {
          repeatedfieldsavearray[subitem.fieldName] = (subitem.repeatingFields || []).map((repeatField, repeatFieldIndex) => {
            const repeatSource = pageData[subitem.fieldName] || {};
            const repeatData = repeatSource[repeatField.fieldIdentifier] || repeatSource[repeatFieldIndex] || {};

            return {
              fieldIdentifier: repeatField.fieldIdentifier,
              fields: (repeatField.fields || []).map((data) => {
                let value = repeatData[data.fieldName] != null ? repeatData[data.fieldName] : "";

                if (data.type == "checkbox") {
                  value = this.getEditCheckCheckboxValue(value);
                }
                if (data.type == "numberanddate") {
                  const numberDateValue = this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier];
                  value = numberDateValue && numberDateValue.numberdata != "" && numberDateValue.datedata != ""
                    ? this.formatDateNum(numberDateValue.datedata) + "_" + numberDateValue.numberdata
                    : "";
                }
                if (data.type == "dateandtime") {
                  value = value ? this.formatDateTime(value) : "";
                }
                if (data.type == "time" && value) {
                  value = this.convertTime(value);
                }

                const repeatedVisibility = this.visibility[data.fieldName + repeatField.fieldIdentifier];
                const nestedVisibility =
                  repeatedVisibility !== undefined && repeatedVisibility !== null
                    ? repeatedVisibility
                    : this.visibility[data.fieldName];
                if (nestedVisibility == "false" || nestedVisibility == false) {
                  value = "";
                }

                return {
                  ...data,
                  value: value,
                  visibility: this.getPayloadFieldVisibility(
                    data.fieldName,
                    repeatField.fieldIdentifier,
                    data.visibility
                  )
                };
              })
            };
          });
          this.isrepeatvalid[subitem.fieldName] = [];
          val = "";
        }
        else if (subitem.type == "dateandtime") {
          val = pageData[subitem.fieldName] ? this.formatDateTime(pageData[subitem.fieldName]) : "";
          itemstatus = "Not Validated";
        }
        else if (subitem.type == "time") {
          val = pageData[subitem.fieldName] ? this.convertTime(pageData[subitem.fieldName]) : "";
          itemstatus = "Not Validated";
        }
        else if (subitem.type == "date") {
          val = pageData[subitem.fieldName];
          itemstatus = "Not Validated";
        }
        else if (subitem.type == "header" || subitem.type == "subHeader") {
          val = pageData[subitem.fieldName];
          itemstatus = "";
        }
        else if (subitem.type == "numberanddate") {
          const numberDateValue = this.numberanddateval[subitem.fieldName];
          val = numberDateValue && numberDateValue.numberdata != "" && numberDateValue.datedata != ""
            ? this.formatDateNum(numberDateValue.datedata) + "_" + numberDateValue.numberdata
            : "";
          itemstatus = "";
        }
        else if (subitem.type == "year" || subitem.type == "scales") {
          val = pageData[subitem.fieldName];
          if (val) {
            val = val.toString();
          }
          itemstatus = "";
        }
        else if (subitem.type == "grid") {
          val = JSON.stringify(this.gridlinkeddatas[subitem.fieldName]);
          itemstatus = "";
        }
        else {
          val = pageData[subitem.fieldName];
          itemstatus = "Not Validated";
        }

        if ((this.visibility[subitem.fieldName] == "false" || this.visibility[subitem.fieldName] == false) && subitem.fieldName != "AESEQ" && subitem.fieldName != "CMSEQ") {
          val = "";
        }

        createdpage.field.push({
          fieldName: subitem.fieldName,
          label: subitem.label,
          type: subitem.type,
          value: (subitem.fieldName === "CMAENO" || subitem.fieldName === "CMSEQ") ? (pageData[subitem.fieldName] || "") : (val || ""),
          status: itemstatus,
          validation: subitem.validation,
          groupOrderNo: subitem.groupOrderNo,
          validatedBy: "",
          limit: subitem.limit,
          validatedAt: "",
          comment: "",
          required: subitem.required,
          options: subitem.options,
          imagePath: subitem.imagePath,
          visibility: this.getPayloadFieldVisibility(subitem.fieldName, null, subitem.visibility),
          qrData: subitem.qrData,
          repeatingFieldData: repeatedfieldsavearray[subitem.fieldName]
        });
      });

      return createdpage;
    },
    applyComputedFieldsToCurrentForm(computedFields = []) {
      if (!Array.isArray(computedFields) || computedFields.length === 0) {
        return;
      }

      this.applyComputedFieldEditability(computedFields);
      const computedFieldsWithValue = this.getFirstComputedFieldValues(computedFields);
      computedFieldsWithValue.forEach((computedField) => {
        if (!computedField || !computedField.fieldName) {
          return;
        }

        this.updateComputedFieldInFormData(computedField.fieldName, computedField.value, computedField.fieldInfo);
        this.updateComputedFieldInSendData(computedField.fieldName, computedField.value, computedField.fieldInfo);
        this.updateComputedDisplayValue(
          this.getEditCheckResultFieldKey(computedField) || computedField.fieldName,
          computedField.value
        );
      });

      if (this.$forceUpdate) {
        this.$forceUpdate();
      }
    },
    applyComputedFieldEditability(computedFields = []) {
      computedFields.forEach((computedField) => {
        if (
          !computedField ||
          !computedField.fieldName ||
          !Object.prototype.hasOwnProperty.call(computedField, "isEditable")
        ) {
          return;
        }

        const fieldName = this.normalizeComputedFieldName(computedField.fieldName);
        if (!fieldName) {
          return;
        }

        const isEditable = computedField.isEditable === true || computedField.isEditable === "true";
        this.setComputedFieldValue(this.computedFieldEditability, fieldName, isEditable);
      });

      this.applyComputedFieldEditabilityOverrides();
    },
    applyComputedFieldEditabilityOverrides() {
      Object.keys(this.computedFieldEditability || {}).forEach((fieldName) => {
        const isEditable = this.computedFieldEditability[fieldName];
        if (isEditable) {
          this.calculatedfields = this.calculatedfields.filter(
            (calculatedField) => !this.isSameComputedField(calculatedField, fieldName)
          );
        } else if (!this.calculatedfields.some(
          (calculatedField) => this.isSameComputedField(calculatedField, fieldName)
        )) {
          this.calculatedfields.push(fieldName);
        }
      });
    },
    getFirstComputedFieldValues(computedFields = []) {
      const selectedByFieldName = {};
      const selectedComputedFields = [];

      computedFields.forEach((computedField) => {
        const normalizedFieldName = this.normalizeComputedFieldName(computedField && computedField.fieldName);
        const selectionKey = this.getComputedFieldSelectionKey(computedField);
        if (!computedField || !normalizedFieldName || !selectionKey) {
          return;
        }

        if (Object.prototype.hasOwnProperty.call(selectedByFieldName, selectionKey)) {
          return;
        }

        if (computedField.value === null || computedField.value === undefined || String(computedField.value).trim() === "") {
          return;
        }

        selectedByFieldName[selectionKey] = true;
        selectedComputedFields.push({
          ...computedField,
          fieldName: String(computedField.fieldName).trim()
        });
      });

      return selectedComputedFields;
    },
    normalizeComputedFieldName(fieldName) {
      return String(fieldName || "").trim().toLowerCase();
    },
    isSameComputedField(fieldName, expectedFieldName) {
      return this.normalizeComputedFieldName(fieldName) === this.normalizeComputedFieldName(expectedFieldName);
    },
    isSameFieldIdentifier(firstIdentifier, secondIdentifier) {
      const firstValue = firstIdentifier === undefined || firstIdentifier === null ? "" : firstIdentifier;
      const secondValue = secondIdentifier === undefined || secondIdentifier === null ? "" : secondIdentifier;
      return String(firstValue).trim() === String(secondValue).trim();
    },
    getEditCheckFieldInfo(fieldInfo) {
      if (!Array.isArray(fieldInfo) || fieldInfo.length === 0) {
        return null;
      }

      return fieldInfo.find((info) =>
        info &&
        Object.prototype.hasOwnProperty.call(info, "fieldIdentifier")
      ) || null;
    },
    getRepeatedFieldValidationKey(fieldName, fieldIdentifier) {
      const identifier = fieldIdentifier === undefined || fieldIdentifier === null ? "" : fieldIdentifier;
      return `${fieldName || ""}${identifier}`;
    },
    getEditCheckResultFieldKey(item = {}) {
      if (!item || !item.fieldName) {
        return "";
      }

      const repeatedFieldInfo = this.getEditCheckFieldInfo(item.fieldInfo);
      if (!repeatedFieldInfo) {
        return item.fieldName;
      }

      return this.getRepeatedFieldValidationKey(item.fieldName, repeatedFieldInfo.fieldIdentifier);
    },
    isEditCheckFieldHidden(fieldKey) {
      if (!fieldKey || !Object.prototype.hasOwnProperty.call(this.visibility || {}, fieldKey)) {
        return false;
      }

      return this.visibility[fieldKey] === false || this.visibility[fieldKey] === "false";
    },
    isEditCheckValidationHidden(validation = {}) {
      return this.isEditCheckFieldHidden(this.getEditCheckResultFieldKey(validation));
    },
    getComputedFieldSelectionKey(computedField = {}) {
      const normalizedFieldName = this.normalizeComputedFieldName(computedField && computedField.fieldName);
      if (!normalizedFieldName) {
        return "";
      }

      const repeatedFieldInfo = this.getEditCheckFieldInfo(computedField.fieldInfo);
      if (!repeatedFieldInfo) {
        return normalizedFieldName;
      }

      return [
        this.normalizeComputedFieldName(repeatedFieldInfo.parentFieldName),
        normalizedFieldName,
        String(
          repeatedFieldInfo.fieldIdentifier === undefined || repeatedFieldInfo.fieldIdentifier === null
            ? ""
            : repeatedFieldInfo.fieldIdentifier
        ).trim()
      ].join("|");
    },
    getCommonValidationForRepeatedField(fieldName, fieldIdentifier) {
      const key = this.getRepeatedFieldValidationKey(fieldName, fieldIdentifier);
      return this.commonvalidations && this.commonvalidations[key]
        ? this.commonvalidations[key]
        : null;
    },
    isRepeatedFieldVisible(fieldName, fieldIdentifier) {
      const repeatedKey = this.getRepeatedFieldValidationKey(fieldName, fieldIdentifier);

      if (Object.prototype.hasOwnProperty.call(this.visibility || {}, repeatedKey)) {
        return this.visibility[repeatedKey] === true || this.visibility[repeatedKey] === "true";
      }

      if (Object.prototype.hasOwnProperty.call(this.visibility || {}, fieldName)) {
        return this.visibility[fieldName] === true || this.visibility[fieldName] === "true";
      }

      return false;
    },
    applyEditCheckFieldVisibility(fieldVisibility = []) {
      if (!Array.isArray(fieldVisibility) || fieldVisibility.length === 0) {
        return;
      }

      fieldVisibility.forEach((visibilityItem) => {
        const fieldKey = this.getEditCheckResultFieldKey(visibilityItem);
        if (!fieldKey) {
          return;
        }

        this.setComputedFieldValue(this.visibility, fieldKey, visibilityItem.isVisible);
      });
    },
    setComputedFieldValue(target, fieldName, value) {
      if (!target) {
        return;
      }

      if (this.$set) {
        this.$set(target, fieldName, value);
      } else {
        target[fieldName] = value;
      }
    },
    updateComputedDisplayValue(fieldName, value) {
      this.setComputedFieldValue(this.calculatedresult, fieldName, value);
      this.setComputedFieldValue(this.previouscalculatedresult, fieldName, value);
    },
    getComputedFieldModelValue(field, value) {
      if (!field || !Array.isArray(field.options)) {
        return value;
      }

      const normalizedValue = String(value || "").trim().toLowerCase();
      const matchingOption = field.options.find((option) => {
        return String((option && option.codevalue) || "").trim().toLowerCase() === normalizedValue
          || String((option && option.optionname) || "").trim().toLowerCase() === normalizedValue;
      });

      if (matchingOption && matchingOption.codevalue !== undefined && matchingOption.codevalue !== null) {
        return matchingOption.codevalue;
      }

      return value;
    },
    updateComputedFieldInFormData(fieldName, value, fieldInfo = null) {
      if (!this.htmlarray || !this.htmlarray[0] || !Array.isArray(this.htmlarray[0].pages)) {
        return false;
      }

      const repeatedFieldInfo = this.getEditCheckFieldInfo(fieldInfo);
      if (repeatedFieldInfo) {
        return this.updateComputedFieldInRepeatedFormDataByInfo(fieldName, value, repeatedFieldInfo);
      }

      for (const page of this.htmlarray[0].pages) {
        if (!Array.isArray(page.field)) {
          continue;
        }

        const pageKey = `pageNo${page.pageNo}`;
        const matchField = page.field.find((field) => this.isSameComputedField(field.fieldName, fieldName));
        if (matchField) {
          const modelValue = this.getComputedFieldModelValue(matchField, value);
          if (!this.formdata[pageKey]) {
            this.setComputedFieldValue(this.formdata, pageKey, {});
          }
          this.setComputedFieldValue(this.formdata[pageKey], matchField.fieldName, modelValue);
          this.setComputedFieldValue(matchField, "value", modelValue);
          this.updateComputedDisplayValue(matchField.fieldName, value);
          return true;
        }

        for (const parentField of page.field) {
          if (!Array.isArray(parentField.repeatingFields)) {
            continue;
          }

          const hasNestedField = parentField.repeatingFields.some((repeatField) =>
            Array.isArray(repeatField.fields) &&
            repeatField.fields.some((field) => this.isSameComputedField(field.fieldName, fieldName))
          );

          if (!hasNestedField || !this.formdata[pageKey] || !this.formdata[pageKey][parentField.fieldName]) {
            continue;
          }

          this.updateComputedFieldInRepeatedFormData(this.formdata[pageKey][parentField.fieldName], fieldName, value);
          return true;
        }
      }

      return false;
    },
    updateComputedFieldInRepeatedFormDataByInfo(fieldName, value, fieldInfo) {
      if (!this.htmlarray || !this.htmlarray[0] || !Array.isArray(this.htmlarray[0].pages)) {
        return false;
      }

      const parentFieldName = fieldInfo && fieldInfo.parentFieldName;
      const fieldIdentifier = fieldInfo && fieldInfo.fieldIdentifier;

      if (!parentFieldName || fieldIdentifier === undefined || fieldIdentifier === null) {
        return false;
      }

      for (const page of this.htmlarray[0].pages) {
        if (!Array.isArray(page.field)) {
          continue;
        }

        const parentField = page.field.find((field) =>
          this.isSameComputedField(field.fieldName, parentFieldName) &&
          Array.isArray(field.repeatingFields)
        );

        if (!parentField) {
          continue;
        }

        const repeatField = parentField.repeatingFields.find((repeatData) =>
          this.isSameFieldIdentifier(repeatData.fieldIdentifier, fieldIdentifier)
        );

        if (!repeatField || !Array.isArray(repeatField.fields)) {
          continue;
        }

        const nestedField = repeatField.fields.find((field) =>
          this.isSameComputedField(field.fieldName, fieldName)
        );

        if (!nestedField) {
          continue;
        }

        const pageKey = `pageNo${page.pageNo}`;
        const modelValue = this.getComputedFieldModelValue(nestedField, value);

        if (!this.formdata[pageKey]) {
          this.setComputedFieldValue(this.formdata, pageKey, {});
        }

        if (!this.formdata[pageKey][parentField.fieldName]) {
          this.setComputedFieldValue(this.formdata[pageKey], parentField.fieldName, {});
        }

        if (!this.formdata[pageKey][parentField.fieldName][repeatField.fieldIdentifier]) {
          this.setComputedFieldValue(
            this.formdata[pageKey][parentField.fieldName],
            repeatField.fieldIdentifier,
            {}
          );
        }

        this.setComputedFieldValue(
          this.formdata[pageKey][parentField.fieldName][repeatField.fieldIdentifier],
          nestedField.fieldName,
          modelValue
        );
        this.setComputedFieldValue(nestedField, "value", modelValue);
        return true;
      }

      return false;
    },
    updateComputedFieldInRepeatedFormData(repeatedRows, fieldName, value) {
      const rows = Array.isArray(repeatedRows)
        ? repeatedRows
        : Object.keys(repeatedRows || {}).map((key) => repeatedRows[key]);

      rows.forEach((row) => {
        if (!row) {
          return;
        }

        Object.keys(row).forEach((key) => {
          if (this.isSameComputedField(key, fieldName)) {
            this.setComputedFieldValue(row, key, value);
          }
        });

        if (Array.isArray(row.fields)) {
          row.fields.forEach((field) => {
            if (field && this.isSameComputedField(field.fieldName, fieldName)) {
              this.setComputedFieldValue(field, "value", this.getComputedFieldModelValue(field, value));
            }
          });
        }
      });
    },
    updateComputedFieldInSendData(fieldName, value, fieldInfo = null) {
      if (!this.sendData || !Array.isArray(this.sendData.pages)) {
        return false;
      }

      const repeatedFieldInfo = this.getEditCheckFieldInfo(fieldInfo);
      if (repeatedFieldInfo) {
        return this.updateComputedFieldInRepeatedSendDataByInfo(fieldName, value, repeatedFieldInfo);
      }

      let isUpdated = false;
      this.sendData.pages.forEach((page) => {
        if (Array.isArray(page.field)) {
          page.field.forEach((field) => {
            if (this.isSameComputedField(field.fieldName, fieldName)) {
              const modelValue = this.getComputedFieldModelValue(field, value);
              this.setComputedFieldValue(field, "value", modelValue != null ? modelValue.toString() : "");
              isUpdated = true;
            }

            if (Array.isArray(field.repeatingFieldData)) {
              field.repeatingFieldData.forEach((repeatData) => {
                if (Array.isArray(repeatData.fields)) {
                  repeatData.fields.forEach((repeatField) => {
                    if (this.isSameComputedField(repeatField.fieldName, fieldName)) {
                      const modelValue = this.getComputedFieldModelValue(repeatField, value);
                      this.setComputedFieldValue(repeatField, "value", modelValue != null ? modelValue.toString() : "");
                      isUpdated = true;
                    }
                  });
                }
              });
            }
          });
        }
      });

      return isUpdated;
    },
    updateComputedFieldInRepeatedSendDataByInfo(fieldName, value, fieldInfo) {
      if (!this.sendData || !Array.isArray(this.sendData.pages)) {
        return false;
      }

      const parentFieldName = fieldInfo && fieldInfo.parentFieldName;
      const fieldIdentifier = fieldInfo && fieldInfo.fieldIdentifier;

      if (!parentFieldName || fieldIdentifier === undefined || fieldIdentifier === null) {
        return false;
      }

      let isUpdated = false;
      this.sendData.pages.forEach((page) => {
        if (!Array.isArray(page.field)) {
          return;
        }

        page.field.forEach((field) => {
          if (!this.isSameComputedField(field.fieldName, parentFieldName) || !Array.isArray(field.repeatingFieldData)) {
            return;
          }

          field.repeatingFieldData.forEach((repeatData) => {
            if (!this.isSameFieldIdentifier(repeatData.fieldIdentifier, fieldIdentifier) || !Array.isArray(repeatData.fields)) {
              return;
            }

            repeatData.fields.forEach((repeatField) => {
              if (this.isSameComputedField(repeatField.fieldName, fieldName)) {
                const modelValue = this.getComputedFieldModelValue(repeatField, value);
                this.setComputedFieldValue(repeatField, "value", modelValue != null ? modelValue.toString() : "");
                isUpdated = true;
              }
            });
          });
        });
      });

      return isUpdated;
    },
   async focusOutFunction(pageno, fieldname, sentvalue) {
  const completePendingFieldValidation = this.startPendingFieldValidation();
  try {
    this.errormsg[fieldname] = "";
    if (this.messagetype[fieldname]) {
      delete this.messagetype[fieldname];
    }

    if (this.isvalid.includes(fieldname)) {
      const index = this.isvalid.indexOf(fieldname);
      this.isvalid.splice(index, 1);
    }

    let value = "";
    if (sentvalue != '') {
      value = sentvalue;
    } else {
      value = this.formdata[`pageNo${pageno}`][fieldname];
    }

    if (value === true) {
      value = "true";
    } else if (value === false) {
      value = "false";
    }

    let idtoken = store.getters.getIdToken;

    if (value == null || value == undefined) {
      value = "";
    }

    value = value.toString();

    let calcfieldarray = await this.getCalculationsForField(fieldname);
    console.log("calcfieldarray", calcfieldarray);

    let computedfieldobj = {};

    if (calcfieldarray.length > 0) {
      await calcfieldarray.forEach(async (eachfields) => {
        computedfieldobj[eachfields] = await this.getValueByKey(eachfields);
      });
    }

    const formDataForValidation = this.getFormDataForEditCheckValidation();

    let checkdata = {
      fieldValue: value,
      fieldName: fieldname,
      templateId: this.templateid,
      computeFields: computedfieldobj,
      siteId: formDataForValidation.siteId,
      studyId: formDataForValidation.studyId || this.stdyid,
      formData: formDataForValidation,
      subjectId: formDataForValidation.subjectId
    };
    await this.trackFieldValidationPromise(
      axios
        .post(
          `${this.baseurl}/custom/editcheck/validatefield`,
          checkdata,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          const fieldVisibility = res.data.fieldVisibility;
          const computedField = res.data.computedField;

          if (res.data.validations && res.data.validations.length > 0) {
            const errorValidation = res.data.validations.find(
              (v) => String(v.messageType || "").toLowerCase() === "error"
            );

            const selectedValidation =
              errorValidation || res.data.validations[0];

            if (
              String(selectedValidation.messageType || "").toLowerCase() ===
              "error"
            ) {
              if (!this.isvalid.includes(fieldname)) {
                this.isvalid.push(fieldname);
              }
            }

            this.errormsg[fieldname] = selectedValidation.message;
            this.messagetype[fieldname] = selectedValidation.messageType;
          }

          this.applyEditCheckFieldVisibility(fieldVisibility);

          if (computedField.length > 0) {
            this.getFirstComputedFieldValues(computedField).forEach(
              (eachcomputedField) => {
                this.htmlarray[0].pages.forEach((eachpages) => {
                  eachpages.field.forEach((eachfields) => {
                    if (
                      this.isSameComputedField(
                        eachfields.fieldName,
                        eachcomputedField.fieldName
                      )
                    ) {
                      const pageKey = `pageNo${eachpages.pageNo}`;

                      if (!this.formdata[pageKey]) {
                        this.setComputedFieldValue(
                          this.formdata,
                          pageKey,
                          {}
                        );
                      }

                      this.setComputedFieldValue(
                        this.formdata[pageKey],
                        eachfields.fieldName,
                        eachcomputedField.value
                      );

                      this.setComputedFieldValue(
                        eachfields,
                        "value",
                        eachcomputedField.value
                      );
                    }
                  });
                });
              }
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
    );
  } finally {
    completePendingFieldValidation();
  }
},
    applyEditCheckConfiguration(editCheckResponse = {}) {
      const response = editCheckResponse || {};
      const computedField = Array.isArray(response.computedField) ? response.computedField : [];
      const editCheckValidation =
        response.editCheckValidation && Array.isArray(response.editCheckValidation.fields)
          ? response.editCheckValidation
          : { fields: [] };
      const pages =
        this.htmlarray &&
          this.htmlarray[0] &&
          Array.isArray(this.htmlarray[0].pages)
          ? this.htmlarray[0].pages
          : [];

      if (computedField.length > 0 && pages.length > 0) {
        for (const computed of this.getFirstComputedFieldValues(computedField)) {
          for (const page of pages) {
            const matchField = page.field.find(f => this.isSameComputedField(f.fieldName, computed.fieldName));
            if (matchField) {
              const pageKey = `pageNo${page.pageNo}`;
              if (!this.formdata[pageKey]) {
                this.setComputedFieldValue(this.formdata, pageKey, {});
              }
              this.setComputedFieldValue(this.formdata[pageKey], matchField.fieldName, computed.value);
              this.setComputedFieldValue(matchField, "value", computed.value);
              break;
            }
          }
        }
      }

      this.editcheckvar = editCheckValidation;
      this.calculatedfields = [];

      for (const editCheck of editCheckValidation.fields || []) {
        for (const calc of editCheck.calculations || []) {
          const field = calc.outputfield;
          if (field && !this.calculatedfields.includes(field)) {
            this.calculatedfields.push(field);
          }
        }

        for (const crossForm of editCheck.crossForms || []) {
          for (const item of crossForm.calculations || []) {
            const field = item.outputfield;
            if (field && !this.calculatedfields.includes(field)) {
              this.calculatedfields.push(field);
            }
          }

          for (const dependent of crossForm.dependencies || []) {
            for (const page of pages) {
              const matchField = page.field.find(
                f => f.fieldName === dependent.targetFieldName
              );
              if (matchField) {
                this.visibility[matchField.fieldName] = dependent.isVisible;
                break;
              }
            }
          }
        }
      }
      this.applyComputedFieldEditabilityOverrides();
    },
    getCustomEditCheckFieldNames(editCheck = {}) {
      const fieldNames = Array.isArray(editCheck.fields)
        ? editCheck.fields.filter(Boolean)
        : [];
      const patterns = [];

      if (typeof editCheck.expression === "string") {
        patterns.push(...(editCheck.expression.match(/\{([^}]+)\}/g) || []));
      }
      if (typeof editCheck.condition === "string") {
        patterns.push(...(editCheck.condition.match(/\{([^}]+)\}/g) || []));
      }

      patterns.forEach((field) => {
        const normalizedField = field.replace(/[{}]/g, "").trim();
        if (normalizedField) {
          fieldNames.push(normalizedField);
        }
      });

      if (fieldNames.length === 0 && editCheck.fieldName) {
        fieldNames.push(editCheck.fieldName);
      }

      return [...new Set(fieldNames)];
    },
    isCustomDependencyRule(editCheck = {}) {
      const actionType = String(editCheck.actionType || "").toLowerCase();
      const ruleType = String(editCheck.ruleType || "").toLowerCase();
      const category = String(editCheck.category || "").toLowerCase();

      return (
        ["hide", "show", "disable", "enable"].includes(actionType) ||
        ruleType === "ui" ||
        category === "dependency"
      );
    },
    isCustomCalculationRule(editCheck = {}) {
      const outputField = editCheck.outputField || editCheck.outputfield;
      const actionType = String(editCheck.actionType || "").toLowerCase();
      const category = String(editCheck.category || "").toLowerCase();

      return Boolean(
        (typeof outputField === "string" && outputField.trim() !== "") ||
        actionType === "calculation" ||
        category === "calculation"
      );
    },
    getOrCreateCustomCrossForm(fieldConfig, target = {}) {
      let crossForm = fieldConfig.crossForms.find((item) =>
        String(item.targetTemplateId || "") === String(target.formId || "") &&
        String(item.targetFormName || "") === String(target.formName || "")
      );

      if (!crossForm) {
        crossForm = {
          targetTemplateId: target.formId || "",
          targetFormName: target.formName || "",
          editCheck: null,
          dependencies: [],
          calculations: []
        };
        fieldConfig.crossForms.push(crossForm);
      }

      return crossForm;
    },
    normalizeCustomEditCheckResponse(customEditChecks = []) {
      const groupedFields = {};

      (customEditChecks || []).forEach((rule) => {
        if (!rule || !rule.fieldName) {
          return;
        }

        if (!groupedFields[rule.fieldName]) {
          groupedFields[rule.fieldName] = {
            fieldName: rule.fieldName,
            type: rule.type || rule.ruleType || "",
            editCheck: [],
            dependencies: [],
            calculations: [],
            crossForms: []
          };
        }

        const fieldConfig = groupedFields[rule.fieldName];
        const target = rule.target || {};
        const targetFieldName =
          target.fieldName ||
          (Array.isArray(rule.fields) && rule.fields.length > 0 ? rule.fields[0] : "");
        const isCrossForm =
          Boolean(target.formId) ||
          (Boolean(target.formName) && target.formName !== rule.formName);

        if (this.isCustomCalculationRule(rule)) {
          const calculation = {
            fields: this.getCustomEditCheckFieldNames(rule),
            expression: rule.expression || rule.condition || "",
            outputfield: rule.outputField || rule.outputfield || "",
            crosstemplate: isCrossForm && target.formId
              ? [
                {
                  targetTemplateId: target.formId,
                  fields: this.getCustomEditCheckFieldNames(rule)
                }
              ]
              : []
          };

          if (isCrossForm) {
            const crossForm = this.getOrCreateCustomCrossForm(fieldConfig, target);
            crossForm.calculations.push(calculation);
          } else {
            fieldConfig.calculations.push(calculation);
          }
          return;
        }

        if (this.isCustomDependencyRule(rule)) {
          const dependency = {
            targetTemplateId: isCrossForm ? (target.formId || "") : this.templateid,
            targetFieldName: isCrossForm ? targetFieldName : "",
            condition: rule.condition || "",
            value: rule.value,
            pageNo: target.pageNo != null ? String(target.pageNo) : "1",
            isVisible: String(rule.actionType || "").toLowerCase() === "hide" ? false : true,
            visibilityfieldname: targetFieldName
          };

          if (isCrossForm) {
            const crossForm = this.getOrCreateCustomCrossForm(fieldConfig, target);
            crossForm.dependencies.push(dependency);
          } else {
            fieldConfig.dependencies.push(dependency);
          }
          return;
        }

        fieldConfig.editCheck.push({ ...rule });
      });

      return {
        templateId: this.templateid,
        formName: this.templatenameforeditcheck,
        studyId: store.getters.getStudyIs,
        version: "1.0",
        fields: Object.values(groupedFields)
      };
    },
    async getcheckcustomeditcheck() {
      let idtoken = store.getters.getIdToken;

      await axios.get(`${this.baseurl}/custom/editcheck/getcheckcustomeditcheck?FormName=${this.templatenameforeditcheck}&studyId=${store.getters.getStudyIs}&version=1.0`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {
          const checkcustomeditcheckresult = Array.isArray(res.data) ? res.data : [];
          this.checkcustomeditcheckobject = checkcustomeditcheckresult;

          if (checkcustomeditcheckresult.length === 0) {
            await this.geteditcheckbytempid();
            return;
          }

          const editCheckValidation = this.normalizeCustomEditCheckResponse(checkcustomeditcheckresult);
          this.applyEditCheckConfiguration({
            computedField: [],
            editCheckValidation
          });
        })
        .catch(async (err) => {
          console.log(err);
          await this.geteditcheckbytempid();
        });
    },
    async geteditcheckbytempid() {

      let idtoken = store.getters.getIdToken;

      await axios.get(`${this.baseurl}/forms/editcheck/geteditcheckbytempid?tempId=${this.templateid}&SiteId=${this.sendData.siteId}&StudyId=${this.stdyid}&SubjectId=${this.sendData.subjectId}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.applyEditCheckConfiguration(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCalculationsForField(fieldName) {

      if (!this.editcheckvar || !Array.isArray(this.editcheckvar.fields)) {
        return [];
      }

      const fieldObj = this.editcheckvar.fields.find(field => field.fieldName === fieldName);
      if (fieldObj) {
        console.log("fieldObj.calculations", fieldObj.calculations);
        return fieldObj.calculations != null && fieldObj.calculations.length != 0 ? fieldObj.calculations[0].fields : []

      }
      else {
        return [];
      }

    },
    async focusOutFunctionForRF(pageno, mainfieldname, fieldname, fieldidentifier, sentvalue) {
  const completePendingFieldValidation = this.startPendingFieldValidation();
  try {
    this.errormsg[fieldname + fieldidentifier] = "";
    if (this.messagetype[fieldname + fieldidentifier]) {
      delete this.messagetype[fieldname + fieldidentifier];
    }

    if (this.isvalid.includes(fieldname + fieldidentifier)) {
      const index = this.isvalid.indexOf(fieldname + fieldidentifier);
      this.isvalid.splice(index, 1);
    }

    let value = "";
    if (sentvalue != '') {
      value = sentvalue;
    } else {
      value = this.formdata[`pageNo${pageno}`][mainfieldname][fieldidentifier][fieldname];
    }
    if (value === true) {
      value = "true";
    } else if (value === false) {
      value = "false";
    }
    console.log("value", value);
    let idtoken = store.getters.getIdToken;
    if (value == null || value == undefined) {
      value = "";
    }
    value = value.toString();

    let calcfieldarray = await this.getCalculationsForField(fieldname);
    console.log("calcfieldarray", calcfieldarray);

    let computedfieldobj = {};
    if (calcfieldarray.length > 0) {
      await calcfieldarray.forEach(async (eachfields) => {
        computedfieldobj[eachfields] = await this.getrepeatedValueByKey(eachfields, mainfieldname, fieldidentifier);
      });
    }

    const formDataForValidation = this.getFormDataForEditCheckValidation();
    let checkdata = {
      "fieldValue": value,
      "fieldName": fieldname,
      "templateId": this.templateid,
      "computeFields": computedfieldobj,
      "siteId": formDataForValidation.siteId,
      "formData": formDataForValidation,
      "studyId": formDataForValidation.studyId || this.stdyid,
      "subjectId": formDataForValidation.subjectId
    };

    await this.trackFieldValidationPromise(
      axios.post(`${this.baseurl}/custom/editcheck/validatefield`, checkdata, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          const fieldVisibility = res.data.fieldVisibility;
          const computedField = res.data.computedField;

          if (res.data.validations.length > 0) {
            const errorValidation = res.data.validations.find(
              (v) => String(v.messageType || "").toLowerCase() === "error"
            );
            const errval = errorValidation || res.data.validations[0];

            if (String(errval.messageType || "").toLowerCase() === "error") {
              if (!this.isvalid.includes(fieldname + fieldidentifier)) {
                this.isvalid.push(fieldname + fieldidentifier);
              }
            }
            this.errormsg[fieldname + fieldidentifier] = errval.message;
            this.messagetype[fieldname + fieldidentifier] = errval.messageType;
          }

          this.applyEditCheckFieldVisibility(fieldVisibility);

          if (computedField.length > 0) {
            this.getFirstComputedFieldValues(computedField).forEach((eachcomputedField) => {
              this.htmlarray[0].pages.forEach((eachpages) => {
                eachpages.field.forEach((eachfields) => {
                  if (eachfields.type == 'RepeatingMeasure' || eachfields.type == 'repeatedmeasure' || eachfields.type == 'repeatingfield') {
                    eachfields.repeatingFields.forEach((subrepeat, repeatindex) => {
                      console.log("subrepeat", subrepeat);
                      subrepeat.fields.forEach((repfields) => {
                        if (this.isSameComputedField(repfields.fieldName, eachcomputedField.fieldName)) {
                          console.log("this.formdata[`pageNo${eachpages.pageNo}`]", this.formdata[`pageNo${eachpages.pageNo}`]);
                          const rowData = this.formdata[`pageNo${eachpages.pageNo}`][mainfieldname][fieldidentifier];
                          this.setComputedFieldValue(rowData, repfields.fieldName, eachcomputedField.value);
                          this.setComputedFieldValue(repfields, "value", eachcomputedField.value);
                        }
                      });
                    });
                  }
                });
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
    );

    // This function gets called when the input loses focus
  } finally {
    completePendingFieldValidation();
  }
},
    istruedateandtime: function (value, compid) {
      if (value != "") {
        const date = new Date(value);
        const year = date.getFullYear();
        if (isNaN(year)) {
          this.errormsg[compid] = "Invalid date and time";
          this.isvalid.push("invdate");
          this.errorclasslist[compid] = "form-control errorlist";
        }
        else {
          this.errormsg[compid] = "";
          // this.isvalid.pop();
        }
      }
    },
    openVideoCallSchedulePopup(patientId) {
      const visitdetails = store.getters.getvisitdetails;
      this.frompatid = visitdetails.Subject_id;
      this.selectedPatientId = patientId;
      this.CreateVideoCallSchedulePopUp = true;
    },
    async removeRepeatedfields(pageIndex, fieldIndex, rfieldIndex, fieldname, fieldIdentifier, pageno) {
      if (this.htmlarray[0].pages[pageIndex].field[fieldIndex].repeatingFields.length > 1) {
        delete (this.formdata[`pageNo${pageno}`][fieldname])[fieldIdentifier];
        this.htmlarray[0].pages[pageIndex].field[fieldIndex].repeatingFields.splice(rfieldIndex, 1);
      }
      else {
        alert("Cannot delete! Atleast one field should be kept on a repeating measure field")
      }
    },
    //     async addrepeatedfields(repeatKey,fieldname,pageno){
    //       this.isrepeatdatavalid={};
    //       this.htmlarray[0].pages.forEach((item) => {      
    //         item.field.forEach((subitem,key) => {    
    //           if(subitem.type=='RepeatingMeasure' || subitem.type=="repeatingfield"  || subitem.type=='repeatingmeasure')
    //           {      
    //             const fieldid =   item.field[repeatKey].repeatingFields[(item.field[repeatKey].repeatingFields).length-1].fieldIdentifier +1;                
    //             if(key == repeatKey && pageno == item.pageNo){
    //               alert("inside the if condition");
    //               this.formdata[`pageNo${pageno}`][fieldname].fieldid={};

    //               item.field[repeatKey].repeatingFields.push({
    //                 fieldIdentifier:fieldid,
    //                 fields: item.field[repeatKey].repeatingFields[0].fields
    //               });
    //                 alert("inside the if condition");
    //             }     

    //           }      
    //         })
    //         });
    //       this.bindData()
    // },
    async addrepeatedfields(repeatKey, pageIndex, fieldname) {
      if (!this.isrepeatdatavalid[fieldname]) {
        this.isrepeatdatavalid[fieldname] = {}
      }

      const repeatingFields = this.htmlarray[0].pages[pageIndex].field[repeatKey].repeatingFields;
      const firstRepeatingField = repeatingFields[0];
      const firstFieldIdentifier = firstRepeatingField.fieldIdentifier;
      const fieldid = Math.max(0, ...repeatingFields.map((field) => Number(field.fieldIdentifier) || 0)) + 1;
      const repeatingFieldTemplate = firstRepeatingField.fields.map((field) => {
        const visibility = this.getPayloadFieldVisibility(
          field.fieldName,
          firstFieldIdentifier,
          field.visibility
        );

        this.setComputedFieldValue(
          this.visibility,
          this.getRepeatedFieldValidationKey(field.fieldName, fieldid),
          visibility
        );

        return {
          ...field,
          visibility
        };
      });

      repeatingFields.unshift({
        fieldIdentifier: fieldid,
        fields: repeatingFieldTemplate
      });
      repeatingFields.forEach((item) => {
        if (!this.isrepeatdatavalid[fieldname][item.fieldIdentifier]) {
          this.isrepeatdatavalid[fieldname][item.fieldIdentifier] = {}
        }
        item.fields.forEach((field) => {
          if (!this.isrepeatdatavalid[fieldname][item.fieldIdentifier][field.fieldName]) {
            this.isrepeatdatavalid[fieldname][item.fieldIdentifier][field.fieldName] = ""
          }
        })

      })

      await this.bindData();

      const pageNo = this.htmlarray[0].pages[pageIndex].pageNo;
      for (const field of repeatingFieldTemplate) {
        await this.focusOutFunctionForRF(
          pageNo,
          fieldname,
          field.fieldName,
          fieldid,
          ""
        );
      }
    },
    async reloadrepeatarray(item) {
      this.repeatedmeasurelistpopup = false;
      this.repeathidden = true;
      this.temprepeatedmeasureval = item;
    },
    async repeatedmeasuremodal(options, pageNo, fieldName) {
      this.repeatedpageno = pageNo;
      this.repeatedfieldname = fieldName;
      this.repeatedoptions = JSON.parse(options);
      this.repeatedmeasurepopup = true;
    },
    async saverepeatedmeasurdata() {
      this.repeathidden = false;
      this.formdata[`pageNo${this.repeatedpageno}`][this.repeatedfieldname] = JSON.stringify(this.repeatedmeasurevalarray);
      this.repeatedmeasurepopup = false;
    },
    async closerepeatedmeasuremodal() {
      this.repeathidden = false;
      this.repeatedmeasurepopup = false;
    },
    async repeatedmeasurlist() {
      this.repeathidden = false;
      this.repeatedmeasurelistpopup = true;
    },
    async repeatedmeasurdatapopup() {
      this.temprepeatedmeasureval = {};
      this.repratmeasureid = new Date();
      this.repeatedmeasurelistpopup = false;
    },
    async deleterepeatedmeasure(item) {
      let indexToDelete = this.repeatedmeasurevalarray.indexOf(item);

      if (indexToDelete !== -1) {
        // Remove the element at the found index
        this.repeatedmeasurevalarray.splice(indexToDelete, 1);
      }
    },
    async addrepeatemesureentries() {
      let temprepeatedval = {};
      this.repratmeasureid = new Date();
      this.temprepeatedmeasureval.ID = this.repratmeasureid;
      temprepeatedval = this.temprepeatedmeasureval;
      this.repeatedmeasurevalarray.unshift({ ...temprepeatedval });
      temprepeatedval = {};
      this.repeatedmeasurlist();
    },
    async addrepeatedmeasure() {

      this.addfield('repeatedmeasure');
    },
    async archive(formId, subId) {
      if (confirm("Are you sure you want to archive this form?")) {
        await axios.put(
          `${this.baseurl}/forms/forms/archive`, {
          createdUserEmail: "string",
          createdUserId: "string",
          createdAt: "2022-11-01T05:24:16.754Z",
          lastModifiedUserEmail: "string",
          lastModifiedUserId: "string",
          lastModifiedAt: "2022-11-01T05:24:16.754Z",
          formId: formId,
          subjectId: subId
        },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            console.log("archive status", res);
          })
          .catch((err) => {
            console.log(err);
            alert("Patient schedule not found!")
          });
      }
    },
    async calculateResult(pageno, caloptions, fieldname) {
      if (!this.calculatedresult[fieldname]) {
        this.calculatedresult[fieldname] = "";
        this.previouscalculatedresult[fieldname] = "0";
      }
      if (this.previouscalculatedresult[fieldname] != this.calculatedresult[fieldname]) {
        let optionnsparsed = JSON.parse(caloptions);
        let firstclcname = this.formdata[`pageNo${pageno}`][optionnsparsed.firstfield];
        let secondcalcname = this.formdata[`pageNo${pageno}`][optionnsparsed.secondfield];
        let calcoperator = optionnsparsed.operations.trim();
        if (firstclcname != undefined && secondcalcname != undefined) {
          if (firstclcname != "" && secondcalcname != "") {
            let firstclcnametoint = parseInt(firstclcname);
            let secondcalcnametoint = parseInt(secondcalcname);
            if (!isNaN(firstclcnametoint) || !isNaN(secondcalcnametoint)) {
              if (calcoperator.trim() == "*") {

                this.calculatedresult[fieldname] = firstclcnametoint * secondcalcnametoint;
              }
              else if (calcoperator.trim() == "+") {
                this.calculatedresult[fieldname] = firstclcnametoint + secondcalcnametoint;
              }
              else if (calcoperator.trim() == "-") {
                this.calculatedresult[fieldname] = firstclcnametoint - secondcalcnametoint;
              }
              else if (calcoperator.trim() == "/") {
                this.calculatedresult[fieldname] = firstclcnametoint / secondcalcnametoint;
              }
              else {
                this.calculatedresult[fieldname] = firstclcnametoint + secondcalcnametoint;
              }
            }
            else {
              this.calculatedresult[fieldname] = firstclcname + secondcalcname;
            }

            console.log("new calculatedresult[fieldname]");
            this.previouscalculatedresult[fieldname] = this.calculatedresult[fieldname];
          }
        }
      }
    },
    async selectfileslot(pageno, fieldname) {
      this.filepageno = pageno;
      this.filefieldname = fieldname;
    },
    truncateInput(event, fieldName, maxLength) {
      const inputValue = event.target.value.toString();
      if (inputValue.length > maxLength) {
        event.target.value = inputValue.slice(0, maxLength);
        this.formdata[`pageNo${item.pageNo}`][fieldName] = event.target.value;
      }
    },
    async helloButton(event, pageno, fieldName) {
      this.formdata[`pageNo${pageno}`][fieldName] = "";
      this.selectedFile = "";
      this.filedata = "";

      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.filedata = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.selectedFile = input.files[0];
        console.log(this.selectedFile);
      }
      await this.submitFile(pageno, fieldName);
    },
    async qrcodefun(fieldname, dataurl) {
      try {
        this.qrcodetxt[fieldname] = await QRCode.toDataURL(dataurl);
      } catch (err) {
        console.error(err)
      }
    },
    async submitFile(pageno, fieldName) {
      var formData = new FormData();
      formData.append("Document", this.selectedFile);
      formData.append("DocumentTypeName", "FORMS_DEV_FILEUPLOAD");
      formData.append("DocumentTitle", "");
      formData.append(
        "DocumentDescription",
        ""
      );
      formData.append("OrganizationId", "");

      await axios
        .post(`${this.fileuploadurl}/create
`, formData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        })

        .then((response) => {
          this.formdata[`pageNo${pageno}`][fieldName] = `${response.data.data[0]},${response.data.data[1]}`
        })
        .catch((err) => {
          console.log(err.data);
        });
    },
    async closemodallll() {
      this.selectedprivilege = "";
      document.body.style.overflowY = "auto";
      this.fieldprivilegepopup = false;
    },
    openModal(label, groupno) {
      if (this.fromUrlStatus && this.isSigned === false) {
        this.showModal = true
        this.assignFieldValue = label
        this.groupNo = groupno
      }
    },
    async assignprivilege(fieldname, label, groupno) {
      if (this.fromUrlStatus && this.isSigned === false) {
        this.showModal = true
        this.assignFieldValue = label
        this.groupNo = groupno
      }
      if (this.requiredrole) {
        if (this.selectedrole == "" || this.selectedrole == null || this.selectedrole == "All") {
          alert("Please select a role");
        }
        else {
          await this.reloadprivilege(fieldname);
          this.selectedfield = fieldname;
          document.body.style.overflowY = "hidden";
          this.fieldprivilegepopup = true;
        }
      }
    },
    async numbanddatefocusoutfun(fieldname) {
      if (!this.numberanddateval.hasOwnProperty(fieldname)) {
        this.numberanddateval[fieldname] = {
          "numberdata": "",
          "datedata": "",
        }
      }
    },
    async reloadprivilege(fieldname) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/forms/forms/getfieldprivilege?RoleId=${this.selectedrole}&TemplateId=${this.templateid}&FieldName=${fieldname}`
          ,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.selectedprivilege = res.data.privilage;
        })
        .catch((err) => {
          console.log("Have error After listed");
          console.log(err);
        });
    },
    async savefieldprivilege() {
      if (this.selectedprivilege == "" || this.selectedprivilege == null) {
        alert("Please select a privilege");
      }
      else {
        // alert("templateid is "+ this.templateid + "roleId is " + this.selectedrole + "fieldname is " + this.selectedfield);
        const idtoken = store.getters.getIdToken;
        await axios
          .post(`${this.baseurl}/forms/forms/addoneprivilage`,
            {
              "fieldName": this.selectedfield,
              "privilage": this.selectedprivilege,
              "roleId": this.selectedrole,
              "templateId": this.templateid

            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            // alert("Privilege added successfully");
            alert(this.$t('navigations.privilege added successfully'))
            this.closemodallll();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async getallroles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/account-core/roles/search?status=ACTIVE`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((res) => {
          this.roles = res.data.data.sort((a, b) =>
            a.role_Name.localeCompare(b.role_Name)
          );
        })
        .catch((err) => {
          console.log("Have error After listed");
          console.log(err);
        });
    },
    // User IP address
    async getuserIp() {
      await axios.get(`https://api.ipify.org?format=json`).then((res) => {
        this.iPaddress = res.data.ip;
      });
    },
    //ends here
    //Date time format starts//
    formatDateTime(inputDate) {
      // const hours = date.getUTCHours().toString().padStart(2, "0");
      // const minutes = date.getUTCMinutes().toString().padStart(2, "0");
      // const seconds = date.getUTCSeconds().toString().padStart(2, "0");
      // const day = date.getUTCDate().toString().padStart(2, "0");
      // const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
      // const year = date.getUTCFullYear();

      // Convert input date to a Date object
      const date = new Date(inputDate);

      // Extract date and time components
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = "00"; // Assuming seconds are always 00 if not provided

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear().toString();
      return `${hours}:${minutes}:${seconds}_${day}-${month}-${year}`;
    },
    formatDateNum(inputDate) {
      // const hours = date.getUTCHours().toString().padStart(2, "0");
      // const minutes = date.getUTCMinutes().toString().padStart(2, "0");
      // const seconds = date.getUTCSeconds().toString().padStart(2, "0");
      // const day = date.getUTCDate().toString().padStart(2, "0");
      // const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
      // const year = date.getUTCFullYear();

      // Convert input date to a Date object
      const date = new Date(inputDate);

      // Extract date components
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear().toString();
      return `${day}-${month}-${year}`;
    },
    payloadDate(inputDate) {
      const date = new Date(inputDate);

      if (isNaN(date)) {
        console.error("Invalid date", inputDate);
        return "";
      }

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;

    },
    convertTime(timeString) {
      // Split the time string into parts
      const timeParts = timeString.split(':');

      // Check if the seconds part is missing
      if (timeParts.length === 2) {
        // Append ':00' to add seconds
        return `${timeString}:00`;
      }

      // If the seconds are already present, return the original time string
      return timeString;
    },
    //date time format ends//
    async testmsgfun() {
      console.log("inside test function");
    },
    //retreive visit info
    async retrievevisitinfo() {
      const normalizedVisitId = (this.visitids || "").trim();
      const visitdetails = JSON.parse(localStorage.getItem("visitdetails") || '{}');
      const fallbackSubjectId =
        this.subjectid ||
        visitdetails.Subject_id ||
        this.sendData.subjectId ||
        "";
      const fallbackSiteId =
        this.siteid ||
        visitdetails.Siteid ||
        this.sendData.siteId ||
        "";

      if (!normalizedVisitId || normalizedVisitId === "0") {
        this.visitdetailsCache = visitdetails;
        console.log("visitdetails = ", visitdetails);
        this.visitname = visitdetails.Visitname;
        this.visitno = visitdetails.Visitno;
        this.subjectidforsend = fallbackSubjectId;
        this.sendData.subjectId = fallbackSubjectId;
        this.sendData.siteId = fallbackSiteId;
        this.sendData.sheduleID = visitdetails.sheduleId;
      }
      else {
        this.visitdetailsCache = visitdetails;
        console.log("visitdetails = ", visitdetails);
        this.sendData.subjectId = fallbackSubjectId;
        this.sendData.siteId = fallbackSiteId;
        this.sendData.sheduleID = visitdetails.sheduleId;
        if (this.issavefun) {
          const idtoken = store.getters.getIdToken;
          await axios
            .get(
              `${this.baseurl}/management/visit/getbyid/${this.visitids}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              if (res.data === "No Visit Found") {
                console.log("No Visit Found");
              }
              this.visitname = res.data.visitFormName;
              this.visitno = res.data.visitNo;
            })
            .catch((err) => {
              console.log(err);
            });
        }
        else {
          this.visitname = visitdetails.Visitname;
          this.visitno = visitdetails.Visitno;
        }

      }
    },
    toggleLanguage() {
      this.displayLanguage = !this.displayLanguage;

    },
    selectLanguage(val) {
      this.displayLanguage = !this.displayLanguage;
      this.selectedLanguage = val;
      this.translatelabel(val);

    },
    save() {
      this.translatelabel.push({
        id: "string",
        language: "string",
        code: "string"

      });

    },
    languagelist: async function () {
      console.log("in language list fun");
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/forms/template/languages`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.language = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkLanguage(language) {
      return this.templist.some((obj) => {
        return obj.languageCode == language.toString()
      }
      )
    },
    translatelabel: async function (language) {
      if (!language) {
        alert(this.$t("Please select language"));
        return;
      }
      if (confirm(`${this.$t("navigations.are you sure you want to convert this form to")} ${this.laguageselected.language}?`)) {
        const loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        const idtoken = store.getters.getIdToken;
        console.log("language : " + language + " TemplateId :" + this.templateid);
        await axios
          .post(`${this.baseurl}/forms/template/translate?id=${this.templateid}&language=${language}`, {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }


          )
          .then((res) => {
            loader.hide();
            console.log("Transilted id is:");
            console.log(res.data);
            this.islanenglish = language;
            this.getformtemplateUpdated(res.data)
            this.displayLanguage = !this.displayLanguage;
            this.gettemplatelist()
            //TODO
          })
          .catch((err) => {
            loader.hide();
            console.log(err);
            if (err.response.data.errors.DomainValidations[0] === "Template with same language, name and version already exist") {
              alert("Form with same language, name and version already exist");
            }
            else {
              alert("Something went wrong while translating the form");
            }
          });
      } else {
        console.log("cancelled language change request");
      }
    },
    getVersionlist: async function (id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/forms/template/getversionhistory?sourceId=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.versionlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    gettemplatelist: async function () {
      let tempname = this.htmlarray[0].templateName;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/forms/template/gettemplatebyname?TemplateName=${tempname}&studyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.templist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getselectedtemplate: async function(){

    // },
    getselectedtemplate: async function (tempid) {
      const loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      const idtoken = store.getters.getIdToken;
      console.log("in get form function");
      await axios
        .get(
          `${this.baseurl}/forms/template/get/${tempid}?api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          loader.hide();
          // console.log(res.data);
          this.htmlarray[0] = res.data;
          this.htmlarray[0].pages.field.forEach((fielddata) => {
            if (fielddata.repeatingFields.length != 0) {
              fielddata.repeatingFields = [{
                "FieldIdentyfier": 1,
                "field": fielddata
              }]
            }
          })
          this.islanenglish = res.data.languageCode;
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
        });

      await this.gettemplatelist();
      await this.bindData();
    },
    async getTemplate() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/forms/template/gettemplatebylang?TemplateName=${this.templateName}&LanguageCode=en`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.htmlarray[0] = res.data;
          this.islanenglish = res.data.languageCode;
        })
        .catch((err) => {
          console.log(err);
        });
      await this.gettemplatelist();
      await this.bindData();
    },
    getformtemplategeneral: async function () {
      let idtoken = store.getters.getIdToken;
      console.log("inside getformtemplate function ");
      await axios.get(`${this.baseurl}/forms/formslibrary/getbyid?id=${this.templateid}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.htmlarray[0] = res.data;
          this.islanenglish = res.data.languageCode;
          this.sourceTemplateId = res.data.sourceTemplateId;
        })
        .catch((err) => {
          console.log(err);
        });

      this.bindData();
    },
    getformtemplate: async function () {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/forms/template/get/${this.templateid}?api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.htmlarray[0] = res.data;
          this.htmlarray[0].pages.forEach((page) => {
            page.field.forEach((fielddata) => {
              if (fielddata.type == "repeatingfield" && fielddata.repeatingFields.length != 0) {
                fielddata.repeatingFields.forEach((data) => {
                  data["value"] = ""
                })
                fielddata.repeatingFields = [{
                  fieldIdentifier: 1,
                  fields: fielddata.repeatingFields,
                }]
              }
            })
          })
          this.islanenglish = res.data.languageCode;
          this.sourceTemplateId = res.data.sourceTemplateId;
          this.domain = res.data.crfTypeId;
        })
        .catch((err) => {
          console.log(err);

        });
      console.log("HTML array is", this.htmlarray[0].pages)
      await this.gettemplatelist();
      await this.bindData();
      await this.getVersionlist(this.sourceTemplateId);
    },
    getformtemplateUpdated: async function (newtempid) {
      const idtoken = store.getters.getIdToken;
      console.log("in get form function");
      await axios
        .get(
          `${this.baseurl}/forms/template/get/${newtempid}?api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.htmlarray[0] = res.data;
          this.islanenglish = res.data.languageCode;
          this.htmlarray[0].pages.forEach((page) => {
            page.field.forEach((fielddata) => {
              if (fielddata.type == "repeatingfield" && fielddata.repeatingFields.length != 0) {
                fielddata.repeatingFields.forEach((data) => {
                  data["value"] = ""
                })

                fielddata.repeatingFields = [{
                  fieldIdentifier: 1,
                  fields: fielddata.repeatingFields,
                }]
              }
            })
          })
        })
        .catch((err) => {
          console.log(err);
        });

      this.bindData();
    },
    isRequired: async function (value, compid, type) {
      if (type == "checkbox") {
        if (value == "false" || value == false || value == "" || value == null || value == undefined) {
          await this.isvalidatefun(compid, "", "false");
        }
        // else {
        //   if(this.isvalid.includes(compid)){
        //     this.isvalid =  this.isvalid.filter(item => item !== compid);
        //   }
        // }
      }
      else {
        if (value == "" || value == null || value == undefined) {
          await this.isvalidatefun(compid, "", "");
        }
        // else {
        //   if(this.isvalid.includes(compid)){
        //     this.isvalid =  this.isvalid.filter(item => item !== compid);
        //   }
        // }
      }
      return;
    },
    ischeckboxRequired: function (value, compid) {
      if (value == "" || value == null || value == undefined || value == "false") {
        this.errormsg[compid] = "Please check the checkbox to proceed.";
        this.messagetype[compid] = "Alert"
        if (!this.isvalid.includes(compid)) {
          this.isvalid.push(compid);
        }
      } else {
        // this.isvalid.pop();
      }
    },
    isrepeatedRequired: async function (value, fieldIdentifier, repeatedfieldName, type) {
      if (type == "checkbox") {
        if (value == "false" || value == false || value == "" || value == null || value == undefined) {
          await this.isvalidatefun(repeatedfieldName, fieldIdentifier, "false");
        }
        // else {
        //   if(this.isvalid.includes(repeatedfieldName+fieldIdentifier)){
        //     this.isvalid =  this.isvalid.filter(item => item !== repeatedfieldName+fieldIdentifier);
        //   }
        // }
      }
      else {
        if (value == "" || value == null || value == undefined || value == false) {
          await this.isvalidatefun(repeatedfieldName, fieldIdentifier, "");
        }
        //  else {
        //   if(this.isvalid.includes(repeatedfieldName+fieldIdentifier)){
        //     this.isvalid =  this.isvalid.filter(item => item !== repeatedfieldName+fieldIdentifier);
        //   }
        // }
      }
    },
    isrepeatedcheckboxRequired: function (value, compid, fieldIdentifier, repeatedfieldName) {
      if (value == "" || value == null || value == undefined || value == "false") {
        this.errormsg[repeatedfieldName + fieldIdentifier] = "Please check the checkbox to proceed.";
        this.messagetype[repeatedfieldName + fieldIdentifier] = "Error"
        if (!this.isvalid.includes(repeatedfieldName + fieldIdentifier)) {
          this.isvalid.push(repeatedfieldName + fieldIdentifier);
        }
      } else {
        // this.isvalid.pop();
      }
    },

    async getbyidforautofill() {

      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/study/getbyidforautofill/${this.stdyid}`
          ,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          if (res.data.config != null) {
            this.autofield = res.data.config;
          }
        })
        .catch((err) => {
          console.log("Have error After listed");
          console.log(err);
        });
    },
    async applyEConsentAutofill() {
      console.log("this.eConsentAutofillStudyData", this.eConsentAutofillStudyData);
      if (!this.autofillfromeconsent || (!this.eConsentAutofillStudyData && !this.eConsentAutofillICFData)) {
        return;
      }
      if (!this.formdata.pageNo1 || typeof this.formdata.pageNo1 !== "object") {
        this.formdata.pageNo1 = {};
      }
      console.log("this.formdata", this.formdata);
      await this.getSiteById();
      await this.getSubjectById();
      this.formdata.pageNo1.SITEID = this.icfsiteid || "";
      this.formdata.pageNo1.SUBJID = this.icfsubjectid || "";
      if (this.eConsentAutofillStudyData) {
        this.formdata.pageNo1.STUDY_TITLE = this.eConsentAutofillStudyData.studyName || "";
        this.formdata.pageNo1.SPONSOR = this.eConsentAutofillStudyData.sponsor || "";
      }

      if (this.eConsentAutofillICFData) {
        this.formdata.pageNo1.STUDYID = this.eConsentAutofillICFData.protocolNumber || "";
        this.formdata.pageNo1.ICFTITLE = this.eConsentAutofillICFData.documentTitle || "";
        this.formdata.pageNo1.ICFVER = this.eConsentAutofillICFData.versionNumber || "";
        this.formdata.pageNo1.ICFVER_DATE = this.eConsentAutofillICFData.effectiveDate || "";
        this.formdata.pageNo1.ICF_LANG = this.eConsentAutofillICFData.language || "";
        this.formdata.pageNo1.IRB_APR_DATE = this.eConsentAutofillICFData.irbApprovalDate || "";
        this.formdata.pageNo1.IRD_EXP_DATE = this.eConsentAutofillICFData.expiryDate || "";
        this.formdata.pageNo1.IRB_REF_NO = this.eConsentAutofillICFData.irbApprovalNumber || "";
      }
    },
    async getSiteById() {
      const idtoken = store.getters.getIdToken;
      return await axios
        .get(`${this.baseurl}/management/site/getbyid?id=` + this.siteid, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let sitedata = res.data;
          this.icfsiteid = sitedata ? sitedata.siteCode ? sitedata.siteCode : "" : "";
        })
        .catch((err) => "");
    },

    async getSubjectById() {
      const idtoken = store.getters.getIdToken;
      return await axios
        .get(`${this.baseurl}/management/patient/getpatientbyid/` + this.subjectid, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let subjectdata = res.data;
          this.icfsubjectid = subjectdata ? subjectdata.subjectId ? subjectdata.subjectId : "" : "";
        })
        .catch((err) => "");
    },
    async getEConsentAutofillData(forceReload = false) {
      if (!this.autofillfromeconsent) {
        return;
      }

      const studyId = this.stdyid || store.getters.getStudyIs || "";
      const icfId = this.icfid || "";
      const requestKey = `${studyId}|${icfId}`;

      if (!forceReload && this.eConsentAutofillKey === requestKey) {
        this.applyEConsentAutofill();
        return;
      }

      if (!studyId && !icfId) {
        return;
      }

      const idtoken = store.getters.getIdToken;
      const headers = {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      };

      this.isEConsentAutofillLoading = true;
      this.eConsentAutofillStudyData = null;
      this.eConsentAutofillICFData = null;

      const studyRequest = studyId
        ? axios.get(`${this.baseurl}/management/study/getbyid`, {
          headers,
          params: { id: studyId },
        }).catch((err) => ({ error: err }))
        : Promise.resolve(null);

      const icfRequest = icfId
        ? axios.get(`${this.baseurl}/management/patientdocument/geticfformbyid/${encodeURIComponent(icfId)}`, {
          headers,
        }).catch((err) => ({ error: err }))
        : Promise.resolve(null);

      try {
        const [studyResponse, icfResponse] = await Promise.all([studyRequest, icfRequest]);

        if (studyResponse && studyResponse.error) {
          console.log("Error fetching e-consent study autofill data:", studyResponse.error);
        } else if (studyResponse) {
          this.eConsentAutofillStudyData = studyResponse.data;
        }

        if (icfResponse && icfResponse.error) {
          console.log("Error fetching e-consent ICF autofill data:", icfResponse.error);
        } else if (icfResponse) {
          this.eConsentAutofillICFData = icfResponse.data;
        }

        this.eConsentAutofillKey = requestKey;
        this.applyEConsentAutofill();
      } finally {
        this.isEConsentAutofillLoading = false;
      }
    },
    bindData: async function () {
      this.totalpages = this.htmlarray[0].totalPages;
      this.htmlarray[0].pages.forEach((item, index) => {
        this.groups[item.pageNo] = [];
        if (!this.formdata[`pageNo${item.pageNo}`]) {
          this.formdata[`pageNo${item.pageNo}`] = {};
        }
        item.field.forEach((subitem, subindex) => {
          if (!Object.keys(this.visibility).includes(subitem.fieldName)) {
            this.visibility[subitem.fieldName] = subitem.visibility;
          }
          if (subitem.type == 'grid') {
            this.gridoptfun(subitem.fieldName, subitem.options[0])
          }
          if (subitem.type == 'calculation') {
            this.calcfunvar[subitem.fieldName] = 1;
          }
          if (this.inputElements.includes(subitem.type)) {
            if (this.autofield[0].site_sub_autofill[0].autofill == true) {
              let autofillsiteid = store.getters.getautofillsiteid != "null" ? store.getters.getautofillsiteid : "";
              let autofisubjectid = store.getters.getautofillsubjectid != "null" ? store.getters.getautofillsubjectid : "";
              if (subitem.fieldName == this.autofield[0].site_sub_autofill[0].labelsubject) {
                console.log("condition for adding subjectid");
                this.formdata[`pageNo${item.pageNo}`][subitem.fieldName] = autofisubjectid;
              }
              if (subitem.fieldName == this.autofield[0].site_sub_autofill[0].labelsite) {
                console.log("condition for adding siteid",);
                this.formdata[`pageNo${item.pageNo}`][subitem.fieldName] = autofillsiteid;
              }
            }
          }
          if (subitem.type == 'numberanddate') {
            this.numbanddatefocusoutfun(subitem.fieldName);
          }
          if (!this.groups[item.pageNo].includes(parseInt(subitem.groupOrderNo))) {
            this.groups[item.pageNo].push(parseInt(subitem.groupOrderNo));
          }
          if (subitem.type == 'RepeatingMeasure' || subitem.type == 'repeatedmeasure' || subitem.type == 'repeatingfield') {
            this.repeatedgroupgroupnos[subitem.fieldName] = [];
            subitem.repeatingFields.forEach((subrepeat, repeatindex) => {
              subrepeat.fields.forEach((field, fieldIndex) => {
                if (!Object.keys(this.visibility).includes(field.fieldName + subrepeat.fieldIdentifier)) {
                  this.visibility[field.fieldName + subrepeat.fieldIdentifier] = field.visibility;
                }
                if (!this.repeatedgroupgroupnos[subitem.fieldName].includes(field.groupOrderNo)) {
                  this.repeatedgroupgroupnos[subitem.fieldName].push(field.groupOrderNo);
                }
                if (!this.formdata[`pageNo${item.pageNo}`][subitem.fieldName]) {
                  this.formdata[`pageNo${item.pageNo}`][subitem.fieldName] = {};
                }
                if (field.type == 'numberanddate') {
                  // this.repeatednumberanddateval[field.fieldName] = true;
                  this.repeatednumbanddatefocusoutfun(field.fieldName + subrepeat.fieldIdentifier);
                }
                subitem.repeatingFields.forEach(async (eachrepeatingdata) => {
                  if (!this.formdata[`pageNo${item.pageNo}`][subitem.fieldName][eachrepeatingdata.fieldIdentifier]) {
                    this.formdata[`pageNo${item.pageNo}`][subitem.fieldName][eachrepeatingdata.fieldIdentifier] = {};
                  }

                })
              })
            })

          }


          if (subitem.validation != "") {
            subitem.validation.forEach((valid) => {
              if (valid == "Required" || valid == "REQUIRED") {
                this.requiredclasslist[subitem.fieldName] = "required";

              }
            });
          }
        });
      });
      this.totalpages = this.htmlarray[0].pages.length;
      await this.getEConsentAutofillData();
    },
    isautofill(fieldName) {
      let isautofillrequired = store.getters.getautofillenabled;
      if (this.autofield[0].site_sub_autofill[0].autofill == true) {
        if (fieldName == this.autofield[0].site_sub_autofill[0].labelsubject || fieldName == this.autofield[0].site_sub_autofill[0].labelsite) {
          if (isautofillrequired != "false") {
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    async repeatednumbanddatefocusoutfun(fieldname) {
      if (!this.repeatednumberanddateval.hasOwnProperty(fieldname)) {
        this.repeatednumberanddateval[fieldname] = {
          "numberdata": "",
          "datedata": "",
        }
      }
    },
    getValidationMessageRefs() {
      if (Array.isArray(this.$refs.validationMsgs)) {
        return this.$refs.validationMsgs.filter(Boolean);
      }

      return this.$refs.validationMsgs ? [this.$refs.validationMsgs] : [];
    },
    getFieldPageNo(fieldName, fieldInfo = null) {
      if (!fieldName || !this.htmlarray[0] || !Array.isArray(this.htmlarray[0].pages)) {
        return null;
      }

      const repeatedFieldInfo = this.getEditCheckFieldInfo(fieldInfo);
      const parentFieldName = repeatedFieldInfo && repeatedFieldInfo.parentFieldName;
      const fieldIdentifier = repeatedFieldInfo && repeatedFieldInfo.fieldIdentifier;

      for (const page of this.htmlarray[0].pages) {
        if (!Array.isArray(page.field)) {
          continue;
        }

        const hasField = page.field.some((field) => {
          if (parentFieldName) {
            if (!this.isSameComputedField(field.fieldName, parentFieldName) || !Array.isArray(field.repeatingFields)) {
              return false;
            }

            return field.repeatingFields.some((repeatingField) => {
              if (
                fieldIdentifier !== undefined &&
                fieldIdentifier !== null &&
                !this.isSameFieldIdentifier(repeatingField.fieldIdentifier, fieldIdentifier)
              ) {
                return false;
              }

              if (!Array.isArray(repeatingField.fields)) {
                return false;
              }

              return repeatingField.fields.some((nestedField) =>
                this.isSameComputedField(nestedField.fieldName, fieldName)
              );
            });
          }

          if (this.isSameComputedField(field.fieldName, fieldName)) {
            return true;
          }

          if (!Array.isArray(field.repeatingFields)) {
            return false;
          }

          return field.repeatingFields.some((repeatingField) => {
            if (this.isSameComputedField(repeatingField.fieldName, fieldName)) {
              return true;
            }

            if (!Array.isArray(repeatingField.fields)) {
              return false;
            }

            return repeatingField.fields.some((nestedField) =>
              this.isSameComputedField(nestedField.fieldName, fieldName)
            );
          });
        });

        if (hasField) {
          return page.pageNo;
        }
      }

      return null;
    },
    getFirstValidationPageNo(validations = []) {
      const pageNumbers = validations
        .map((item) => this.getFieldPageNo(item && item.fieldName, item && item.fieldInfo))
        .filter((pageNo) => Number.isFinite(pageNo));

      return pageNumbers.length > 0 ? Math.min(...pageNumbers) : null;
    },
    async scrollToFirstValidationMessage(messageTypes = ["Error"]) {
      await this.$nextTick();

      const expectedMessageTypes = Array.isArray(messageTypes) && messageTypes.length > 0
        ? messageTypes
        : ["Error"];
      const firstVisibleMessage = this.getValidationMessageRefs().find((validationMessage) => {
        const hasMessage = typeof validationMessage.errorMsg === "string"
          && validationMessage.errorMsg.trim() !== "";
        const currentMessageType = String(validationMessage.messageType || "").trim().toLowerCase();
        const hasExpectedType = expectedMessageTypes.some((messageType) =>
          currentMessageType === String(messageType || "").trim().toLowerCase()
        );
        const isVisible = validationMessage.$el && validationMessage.$el.offsetParent !== null;

        return hasMessage && hasExpectedType && isVisible;
      });

      if (!firstVisibleMessage || !firstVisibleMessage.$el) {
        return false;
      }

      firstVisibleMessage.$el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      return true;
    },
    trackFieldValidationPromise(validationPromise) {
      if (!Array.isArray(this.pendingFieldValidationPromises)) {
        this.pendingFieldValidationPromises = [];
      }

      const trackedPromise = validationPromise.catch((err) => {
        console.log(err);
        return null;
      }).then((result) => {
        const index = this.pendingFieldValidationPromises.indexOf(trackedPromise);
        if (index !== -1) {
          this.pendingFieldValidationPromises.splice(index, 1);
        }
        return result;
      });

      this.pendingFieldValidationPromises.push(trackedPromise);
      return trackedPromise;
    },
    startPendingFieldValidation() {
      if (!Array.isArray(this.pendingFieldValidationPromises)) {
        this.pendingFieldValidationPromises = [];
      }

      let resolveValidation;
      const trackedPromise = new Promise((resolve) => {
        resolveValidation = resolve;
      });

      this.pendingFieldValidationPromises.push(trackedPromise);

      return () => {
        const index = this.pendingFieldValidationPromises.indexOf(trackedPromise);
        if (index !== -1) {
          this.pendingFieldValidationPromises.splice(index, 1);
        }
        resolveValidation();
      };
    },
    async waitForPendingFieldValidations() {
      while (Array.isArray(this.pendingFieldValidationPromises) && this.pendingFieldValidationPromises.length > 0) {
        const pendingValidations = this.pendingFieldValidationPromises.slice();
        await Promise.all(pendingValidations);
      }
    },
    hasFieldValidationError() {
      return Object.keys(this.messagetype || {}).some((key) => {
        if (this.isEditCheckFieldHidden(key)) {
          return false;
        }
        const hasMessage = this.errormsg && typeof this.errormsg[key] === "string"
          && this.errormsg[key].trim() !== "";
        const isError = String(this.messagetype[key] || "").trim().toLowerCase() === "error";

        return hasMessage && isError;
      });
    },
    async loadComputedFieldsOnFormLoad() {
      const idtoken = store.getters.getIdToken;
      const formDataForValidation = this.getFormDataForEditCheckValidation();
      const validationPayload = {
        studyId: formDataForValidation.studyId || this.stdyid || store.getters.getStudyIs || "",
        formId: null,
        formName: formDataForValidation.formName || this.templatenameforeditcheck || this.templateName || this.htmlarray?.[0]?.templateName || "",
        siteId: formDataForValidation.siteId || this.siteid || "",
        subjectId: formDataForValidation.subjectId || this.subjectid || this.subjectidforsend || "",
        visitNo: formDataForValidation.visitNo || this.visitno || this.selectedFormData?.Visitno || "",
        formData: formDataForValidation
      };

      try {
        const result = await axios.post(
          `${this.baseurl}/custom/editcheck/getstudyeditchecksbyform`,
          validationPayload,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            }
          }
        );
        const responseData = result.data || {};
        const computedFields = Array.isArray(responseData.computedField)
          ? responseData.computedField
          : [];
        this.applyComputedFieldsToCurrentForm(computedFields);
      } catch (err) {
        console.error("Error loading computed fields on form load:", err);
      }
    },
    async commonvalidationfun(formId, saveorsubmit) {
      let input = [];
      let hasErrorValidation = false;
      this.commonvalidations = {};
      await this.waitForPendingFieldValidations();
      if (this.hasFieldValidationError()) {
        await this.scrollToFirstValidationMessage(["Error"]);
        return false;
      }
      console.log("this.sendData", this.sendData, "formid=", formId);
      const idtoken = store.getters.getIdToken;
      const formDataForValidation = this.getFormDataForEditCheckValidation();
      const validationPayload = {
        studyId: this.sendData.studyId || this.stdyid || store.getters.getStudyIs || "",
        formId: null,
        formName: this.sendData.formName || this.templatenameforeditcheck || this.templateName || this.htmlarray?.[0]?.templateName || "",
        siteId: this.sendData.siteId || this.siteid || "",
        subjectId: this.sendData.subjectId || this.subjectid || this.subjectidforsend || "",
        visitNo: this.sendData.visitNo || this.visitno || this.selectedFormData?.Visitno || "",
        formData: formDataForValidation
      };
      try {
        const result = await axios.post(
          `${this.baseurl}/custom/editcheck/getstudyeditchecksbyform`,
          validationPayload,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            }
          }
        );

        console.log("result of common validation = ", result);
        const responseData = result.data || {};
        const computedFields = Array.isArray(responseData.computedField) ? responseData.computedField : [];
        const fieldVisibility = Array.isArray(responseData.fieldVisibility) ? responseData.fieldVisibility : [];
        this.applyEditCheckFieldVisibility(fieldVisibility);
        this.applyComputedFieldsToCurrentForm(computedFields);
        input = Array.isArray(responseData.validations)
          ? responseData.validations.filter((validation) => !this.isEditCheckValidationHidden(validation))
          : [];
        const errorValidations = input.filter((validation) =>
          String((validation && validation.messageType) || "").toLowerCase() === "error"
        );
        hasErrorValidation = errorValidations.length > 0;
        if (hasErrorValidation) {
          alert(this.$t('One or more edit checks failed. Please review and amend the entries before saving.'));
        }

      } catch (err) {
        console.error("Error fetching privileges:", err);
      }


      this.commonvalidations = input.reduce((acc, item) => {
        const fieldKey = this.getEditCheckResultFieldKey(item);
        if (fieldKey) {
          acc[fieldKey] = item;
        }
        return acc;
      }, {});

      const errorValidations = input.filter((validation) =>
        String((validation && validation.messageType) || "").toLowerCase() === "error"
      );
      const firstValidationPageNo = this.getFirstValidationPageNo(errorValidations);

      if (firstValidationPageNo && this.pageno !== firstValidationPageNo) {
        this.pageno = firstValidationPageNo;
      }

      if (hasErrorValidation) {
        await this.scrollToFirstValidationMessage(["Error"]);
      }
      return !hasErrorValidation;
    },
    hasSavedFormId() {
      return this.saveid !== undefined && this.saveid !== null && this.saveid !== "";
    },
    async saveFormAndReturnId() {
      if (this.isSaving) {
        return this.hasSavedFormId() ? this.saveid : null;
      }

      this.isSaving = true;
      this.bothButtonDisabled = true;
      const originalPage = this.pageno;

      try {
        if (this.requiredvalidate) {
          await this.validate();
        }

        if (this.isvalid.length !== 0 || !this.issavefun) {
          return null;
        }

        if (this.hasSavedFormId()) {
          this.editFun();
          this.sendData.formId = this.saveid;
          if (!(await this.commonvalidationfun(null, "invite-save"))) {
            return null;
          }
          await formService.editdata(this.sendData);
          return this.saveid;
        }

        this.pageno = 1;
        await this.savefun();

        let scheduleId = null;
        if (this.encodedFormList !== undefined && this.requirednewform == true) {
          scheduleId = await this.NewFormSave(false);
        }

        if (this.sendData.Subject_id == "") {
          this.sendData.Subject_id = this.subjectidforsend;
        }

        if (scheduleId) {
          this.sendData.sheduleID = scheduleId;
        }

        if (!(await this.commonvalidationfun(null, "invite-save"))) {
          return null;
        }
        this.saveid = await formService.apicall(this.sendData, scheduleId);
        this.sendData.formId = this.saveid;

        if (!this.saveid) {
          return null;
        }

        this.nextPageClick = true;

        if (this.totalpages === 1) {
          return this.saveid;
        }

        for (let pageNumber = 2; pageNumber <= this.totalpages; pageNumber++) {
          this.pageno = pageNumber;
          this.editFun();
          this.sendData.formId = this.saveid;
          if (!(await this.commonvalidationfun(null, "invite-save"))) {
            return null;
          }
          await formService.editdata(this.sendData);
        }

        return this.saveid;
      } finally {
        if (Object.keys(this.commonvalidations || {}).length === 0) {
          this.pageno = originalPage;
        }
        this.isSaving = false;
        this.bothButtonDisabled = false;
      }
    },
    testfun: async function () {
      if (this.isSaving) return;
      this.isSaving = true;

      this.bothButtonDisabled = true;
      try {
        if (this.requiredvalidate) {
          await this.validate();
        }

        if (this.isvalid.length === 0 && this.issavefun) {
          if (this.hasSavedFormId()) {
            this.editFun();
            this.sendData.formId = this.saveid;
            if (!(await this.commonvalidationfun(null, "save"))) {
              return;
            }
            const isEdited = await formService.editdata(this.sendData);

            if (this.hasSavedFormId() && isEdited) {
              alert(this.$t('navigations.form saved successfully'));
              // this.$router.go(-1);
            }
          } else if (this.totalpages === 1) {
            await this.savefun();

            //First call NewFormSave
            let scheduleId = null;
            if (this.encodedFormList !== undefined && this.requirednewform == true) {
              scheduleId = await this.NewFormSave(false);
            }
            console.log("this.subjectidforsend:", this.subjectidforsend);
            if (this.sendData.Subject_id == "") {
              this.sendData.Subject_id = this.subjectidforsend;
            }
            console.log("dddddddddddddddddddddddddddddddddddddddd:", this.sendData);

            //Then call apicall with scheduleId
            if (scheduleId) {
              this.sendData.sheduleID = scheduleId;
            }

            if (!(await this.commonvalidationfun(null, "save"))) {
              return;
            }
            this.saveid = await formService.apicall(this.sendData, scheduleId);
            this.sendData.formId = this.saveid;

            if (this.saveid) {
              alert(this.$t('navigations.form saved successfully'));
              // this.$router.go(-1);
            }
          }
        }
      } finally {
        this.isSaving = false;
        this.bothButtonDisabled = false;
      }
    },

    //   testfun: async function () {
    //     if (this.isSaving) return;
    //     this.isSaving = true;
    //     this.bothButtonDisabled=true
    //     try {
    //     if (this.requiredvalidate) { await this.validate(); }

    //     if (this.isvalid.length == 0) {
    //       if (this.issavefun) {
    //         if (this.totalpages == 1) {
    //           this.savefun();
    //             this.saveid = await formService.apicall(this.sendData);
    //             if (this.saveid != undefined || this.saveid != null) {
    //               if (this.encodedFormList != undefined) {
    //                 await this.NewFormSave(false);
    //               }
    //               // alert("Form saved successfully")
    //               alert(this.$t('navigations.form saved successfully'))
    //               this.$router.go(-1);
    //             }
    //         }
    //         else {
    //           if (this.saveid != undefined || this.saveid != null) {
    //             this.editFun();
    //               this.sendData.formId = this.saveid;
    //               await formService.editdata(this.sendData);
    //               if (this.saveid != undefined || this.saveid != null) {
    //                 // alert("Form saved successfully")
    //                 alert(this.$t('navigations.form saved successfully'))
    //                 this.$router.go(-1);
    //               }
    //           }
    //         }
    //       }
    //     }
    //     } finally {
    //       this.isSaving = false;
    //       this.bothButtonDisabled=false
    // }
    //   },
    // async NewFormSave(isReviewAndSubmit) {
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .post(`${this.baseurl}/management/patientschedule/addadditionalforms`,
    //       {
    //         "createdUserEmail": "string",
    //         "createdUserId": "string",
    //         "createdAt": "2024-10-11T08:24:19.504Z",
    //         "lastModifiedUserEmail": "string",
    //         "lastModifiedUserId": "string",
    //         "lastModifiedAt": "2024-10-11T08:24:19.504Z",
    //         "formId": this.saveid,
    //         "isReviewAndSubmit": isReviewAndSubmit
    //       },
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       })
    //     .then((res) => {
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    async NewFormSave(isReviewAndSubmit) {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.post(
          `${this.baseurl}/management/patientschedule/addadditionalforms`,
          {
            createdUserEmail: "string",
            createdUserId: "string",
            createdAt: new Date().toISOString(),
            lastModifiedUserEmail: "string",
            lastModifiedUserId: "string",
            lastModifiedAt: new Date().toISOString(),

            formId: this.saveid,
            isReviewAndSubmit: isReviewAndSubmit,

            subjectId: this.localScheduledVisit.Subject_id,
            visitId: this.localScheduledVisit.Visit_id,
            activityScheduleId: this.localScheduledVisit.ActivityScheduleId,
            templateId: this.templateid
          },
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        return res.data;
      } catch (err) {
        console.error("Error in NewFormSave:", err);
        return null;
      }
    },

    async gridoptfun(fieldname, gridoptions) {
      this.gridoptarray[fieldname] = JSON.parse(gridoptions);
      this.gridlinkeddatas[fieldname] = {};

      this.gridlinkeddatas[fieldname] = JSON.parse(gridoptions)[0].Fielddata;
    },
    //     reviewAndSubmit: async function () {
    //       if (this.isreviewandsubmitbtn) return;
    //       this.isreviewandsubmitbtn = true;
    //       this.bothButtonDisabled = true;
    //       try {
    //       if (this.requiredvalidate) { await this.validate(); }

    //       if (this.isvalid.length == 0) {
    //         if (this.issavefun) {
    //           if (this.totalpages == 1) {
    //             await this.savefun();
    //               this.decodedFormList
    //               this.saveid = await formService.apicall(this.sendData);
    //               let isfrompatientschedule = store.getters.getfrompatientschedule;
    //               if (isfrompatientschedule!=null && isfrompatientschedule!='null'&& isfrompatientschedule!="") {
    //                 this.NewFormSave(true);
    //               }
    //               await formService.isreviewstatus(this.saveid, this.selectedFormData);
    //               if (this.saveid != undefined || this.saveid != null) {
    //                 // alert("Form submitted successfully")
    //                 alert(this.$t('navigations.form submitted successfully'))
    //                 this.$router.go(-1);
    //               }

    //           }
    //           else {
    //             this.editFun();
    //               this.sendData.formId = this.saveid;
    //               await formService.editdata(this.sendData);
    //               await formService.isreviewstatus(this.saveid);
    //               if (this.saveid != undefined || this.saveid != null) {
    //                 // alert("Form submitted successfully")
    //                 alert(this.$t('navigations.form submitted successfully'))
    //                 this.$router.go(-1);
    //               }

    //           }

    //         }
    //       }
    //  } finally {
    //     this.isreviewandsubmitbtn = false;
    //     this.bothButtonDisabled = false;
    //   }
    //     },
    reviewAndSubmit: async function () {
      if (this.isreviewandsubmitbtn) return;
      this.isreviewandsubmitbtn = true;
      this.bothButtonDisabled = true;
      try {
        if (this.requiredvalidate) {
          await this.validate();
        }

        if (this.isvalid.length === 0 && this.issavefun) {
          if (this.hasSavedFormId()) {
            this.editFun();
            this.sendData.formId = this.saveid;
            if (!(await this.commonvalidationfun(null, "submit"))) {
              return;
            }
            const isEdited = await formService.editdata(this.sendData);

            await formService.isreviewstatus(this.saveid, this.selectedFormData);

            if (this.hasSavedFormId() && isEdited) {
              alert(this.$t('navigations.form submitted successfully'));
              // this.$router.go(-1);
            }
          } else if (this.totalpages === 1) {
            await this.savefun();

            // First call NewFormSave if from patient schedule
            let scheduleId = null;
            if (this.encodedFormList !== undefined && this.requirednewform == true) {
              scheduleId = await this.NewFormSave(false);
            }

            //Then call apicall with scheduleId
            if (scheduleId) {
              this.sendData.sheduleID = scheduleId;
            }

            if (!(await this.commonvalidationfun(null, "submit"))) {
              return;
            }
            this.saveid = await formService.apicall(this.sendData, scheduleId);
            this.sendData.formId = this.saveid;

            await formService.isreviewstatus(this.saveid, this.selectedFormData);

            if (this.saveid) {
              alert(this.$t('navigations.form submitted successfully'));
              // this.$router.go(-1);
            }
          }
        }
      } finally {
        this.isreviewandsubmitbtn = false;
        this.bothButtonDisabled = false;
      }
    },
    validate: async function () {
      this.errorsort = {};
      this.errorclasslist = {};
      this.commonvalidations = {};

      // Loop through pages with for...of
      for (const item of this.htmlarray[0].pages) {
        const pagenumber = `pageNo${item.pageNo}`;

        if (item.pageNo === this.pageno) {
          // Loop through fields with for...of
          for (const subitem of item.field) {
            // Repeating field scenario
            if (subitem.type === 'repeatingfield') {
              this.isrepeatdatavalid[subitem.fieldName] = {};

              // Loop through repeatingFields
              for (const eachrepeatingdata of subitem.repeatingFields) {
                // Loop through the fields in repeatingFields
                for (const field of eachrepeatingdata.fields) {
                  if (field.validation) {
                    // Loop through each validation
                    for (const valid of field.validation) {
                      if (valid === 'Required' || valid === 'REQUIRED') {
                        await this.isrepeatedRequired(
                          this.formdata[pagenumber][subitem.fieldName][eachrepeatingdata.fieldIdentifier][field.fieldName],
                          eachrepeatingdata.fieldIdentifier,
                          field.fieldName,
                          field.type
                        );
                      }
                    }
                  }
                }
              }

            } else {
              // Non-repeating field scenario
              if (subitem.validation) {
                for (const valid of subitem.validation) {

                  if (valid === 'Required' || valid === 'REQUIRED') {

                    await this.isRequired(
                      this.formdata[pagenumber][subitem.fieldName],
                      subitem.fieldName,
                      subitem.type
                    );

                  }
                }
              }
            }
          }
        }
      }
      await this.scrollToFirstValidationMessage(["Error"]);
      return;
    },
    // save and edit starts
    async isvalidatefun(fieldname, fieldidentifier, receveddata) {
      let visibility = this.visibility[fieldname];
      if (visibility == true || visibility == 'true') {

        let idtoken = store.getters.getIdToken;

        const formDataForValidation = this.getFormDataForEditCheckValidation();
        let checkdata = {
          "fieldValue": receveddata,
          "fieldName": fieldname,
          "templateId": this.templateid,
          "computeFields": {},
          "siteId": formDataForValidation.siteId,
          "formData": formDataForValidation,
          "studyId": formDataForValidation.studyId || this.stdyid,
          "subjectId": formDataForValidation.subjectId
        }
        await this.trackFieldValidationPromise(axios.post(`${this.baseurl}/custom/editcheck/validatefield`, checkdata,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.data.validations.length > 0) {
              let selectedValidation;

              if (fieldidentifier == "") {
                // Pick alert validation if available, else pick the first one
                const errorValidation = res.data.validations.find(v =>
                  String(v.messageType || "").toLowerCase() === "error"
                );
                selectedValidation = errorValidation || res.data.validations[0];

                if (String(selectedValidation.messageType || "").toLowerCase() === "error") {
                  if (!this.isvalid.includes(fieldname)) {
                    this.isvalid.push(fieldname);
                  }
                }

                this.errormsg[fieldname] = selectedValidation.message;
                this.messagetype[fieldname] = selectedValidation.messageType;
              } else {
                // Again pick alert validation or default to first
                const errorValidation = res.data.validations.find(v =>
                  String(v.messageType || "").toLowerCase() === "error"
                );
                selectedValidation = errorValidation || res.data.validations[0];

                if (String(selectedValidation.messageType || "").toLowerCase() === "error") {
                  const key = fieldname + fieldidentifier;
                  if (!this.isvalid.includes(key)) {
                    this.isvalid.push(key);
                  }
                }

                const key = fieldname + fieldidentifier;
                this.errormsg[key] = selectedValidation.message;
                this.messagetype[key] = selectedValidation.messageType;
              }
            }

            return;
          })
          .catch((err) => {
            console.log(err);
            return;
          }));

      }
      else {
        if (this.isvalid.includes(fieldname)) {
          const index = this.isvalid.indexOf(fieldname);
          this.isvalid.splice(index, 1);

        }
      }
    },
    savefun: async function () {
      console.clear();
      console.log("Form data is ...............", this.formdata);
      const storevisitdetails = store.getters.getvisitdetails;
      const parsedstorevisitdetails =
        typeof storevisitdetails === "string"
          ? JSON.parse(storevisitdetails || "{}")
          : (storevisitdetails || {});
      const localvisitdetails = JSON.parse(localStorage.getItem("visitdetails") || "{}");
      const visitdetails =
        (this.visitdetailsCache && Object.keys(this.visitdetailsCache).length > 0)
          ? this.visitdetailsCache
          : (Object.keys(parsedstorevisitdetails).length > 0 ? parsedstorevisitdetails : localvisitdetails);

      let isfrompatientschedule = store.getters.getfrompatientschedule;
      this.sendData.pages = [];
      this.sendData.totalPages = this.htmlarray[0].totalPages;
      this.sendData.templateId = this.htmlarray[0].templateId;
      this.sendData.studyId = this.stdyid || store.getters.getStudyIs;
      this.sendData.folderId = (this.htmlarray[0].folderId ? this.htmlarray[0].folderId : "");
      this.sendData.sheduleID = isfrompatientschedule == 'frompatientschedule'
        ? ""
        : (this.htmlarray[0].sheduleID ? this.htmlarray[0].sheduleID : (visitdetails.sheduleId ? visitdetails.sheduleId : this.sendData.sheduleID));
      this.sendData.visitNo = isfrompatientschedule == 'frompatientschedule' ? this.selectedFormData.Visitno : this.visitno;
      this.sendData.siteId = isfrompatientschedule == 'frompatientschedule'
        ? (this.selectedFormData.Siteid || this.sendData.siteId || this.siteid || "")
        : (visitdetails && visitdetails.Siteid ? visitdetails.Siteid : (this.sendData.siteId || this.siteid || ""));
      this.sendData.subjectId = isfrompatientschedule == 'frompatientschedule'
        ? this.selectedFormData.Subject_id
        : (visitdetails && visitdetails.Subject_id ? visitdetails.Subject_id : (this.sendData.subjectId || this.subjectid || ""));
      this.sendData.sourceID = this.iPaddress;
      this.sendData.dataSource = "Web Browser";
      this.sendData.formName = isfrompatientschedule == 'frompatientschedule' ? this.selectedFormData.Template_name : this.htmlarray[0].templateName;
      this.sendData.visitId =
        this.visitids && this.visitids.trim() !== "0" ? this.visitids : "";
      this.sendData.version = this.htmlarray[0].version;
      this.sendData.visitName = isfrompatientschedule == 'frompatientschedule' ? this.selectedFormData.Visitname : this.visitname;
      let createdpage = {};
      createdpage.pageName = this.htmlarray[0].pages[0].pageName;
      createdpage.pageNo = this.htmlarray[0].pages[0].pageNo;
      createdpage.pageStatus = this.htmlarray[0].pages[0].status;
      createdpage.field = [];
      let repeatedfieldsavearray = {};
      this.htmlarray[0].pages[0].field.forEach((subitem) => {
        let val;
        let itemstatus;

        if (subitem.type == 'checkbox') {
          val = (this.formdata[`pageNo${this.pageno}`][subitem.fieldName] != null) ? (this.formdata[`pageNo${this.pageno}`][subitem.fieldName].toString()) : "false";
          itemstatus = "Not Validated";
        }
        else if (subitem.type === 'RepeatingMeasure' || subitem.type === 'repeatingfield'
          || subitem.type === 'repeatedmeasure') {
          repeatedfieldsavearray[subitem.fieldName] = subitem.repeatingFields.map(repeatField => {
            return {
              fieldIdentifier: repeatField.fieldIdentifier,
              fields: repeatField.fields.map(data => {
                let value = this.formdata[`pageNo${this.pageno}`][subitem.fieldName][repeatField.fieldIdentifier][data.fieldName];
                if (data.type == 'checkbox') {
                  value = value ? value.toString() : "false"
                }
                if (data.type == 'numberanddate') {
                  value = this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].numberdata != '' && this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].datedata != '' ? this.formatDateNum(this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].datedata) + "_" + this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].numberdata : ""
                }
                if (data.type == 'dateandtime') {
                  value = value ? this.formatDateTime(value) : ""
                }
                if (data.type == 'time' && value) {
                  value = this.convertTime(value)
                }
                if (this.visibility[data.fieldName] == "false" || this.visibility[data.fieldName] == false) {
                  val = "";
                }
                return {
                  ...data,
                  value: value,
                  visibility: this.getPayloadFieldVisibility(
                    data.fieldName,
                    repeatField.fieldIdentifier,
                    data.visibility
                  )
                };
              })
            };
          });
          this.isrepeatvalid[subitem.fieldName] = [];
          val = "";
        }
        else if (subitem.type == 'dateandtime') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName] ? this.formatDateTime(this.formdata[`pageNo${this.pageno}`][subitem.fieldName]) : "";
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'time') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName] ? this.convertTime(this.formdata[`pageNo${this.pageno}`][subitem.fieldName]) : ""
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'date') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName];
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'header' || subitem.type == 'subHeader') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName];
          itemstatus = "";
        }
        else if (subitem.type == 'numberanddate') {
          val = this.numberanddateval[subitem.fieldName].numberdata != '' && this.numberanddateval[subitem.fieldName].datedata != '' ? this.formatDateNum(this.numberanddateval[subitem.fieldName].datedata) + "_" + this.numberanddateval[subitem.fieldName].numberdata : ""
          itemstatus = "";
        }
        else if (subitem.type == 'year') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName]
          if (val) {
            val = val.toString();
          }
          itemstatus = "";
        }
        else if (subitem.type == 'grid') {
          val = JSON.stringify(this.gridlinkeddatas[subitem.fieldName]);
          itemstatus = "";
        }
        else if (subitem.type == 'scales') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName]
          if (val) {
            val = val.toString();
          }
          itemstatus = "";
        }
        else {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName]
          itemstatus = "Not Validated"
        }
        if (this.visibility[subitem.fieldName] == "false" || this.visibility[subitem.fieldName] == false && (subitem.fieldName != 'AESEQ' || subitem.fieldName != 'CMSEQ')) {
          val = "";
        }
        console.log("Sub item is......", subitem.fieldName, "value is....", subitem);
        console.log("Val is............", this.formdata[`pageNo${this.pageno}`][subitem.fieldName]);
        createdpage.field.push({
          fieldName: subitem.fieldName,
          label: subitem.label,
          type: subitem.type,
          value: (subitem.fieldName === 'CMAENO' || subitem.fieldName === 'CMSEQ') ? this.formdata[`pageNo${this.pageno}`][subitem.fieldName] : (val || ""),
          status: itemstatus,
          validation: subitem.validation,
          groupOrderNo: subitem.groupOrderNo,
          validatedBy: "",
          limit: subitem.limit,
          validatedAt: "",
          comment: "",
          required: subitem.required,
          options: subitem.options,
          imagePath: subitem.imagePath,
          visibility: this.getPayloadFieldVisibility(subitem.fieldName, null, subitem.visibility),
          qrData: subitem.qrData,
          repeatingFieldData: repeatedfieldsavearray[subitem.fieldName]
        });

      });

      console.log("createdpage is", createdpage)
      this.sendData.pages.push(createdpage);
      // this.saveid = await formService.apicall(this.sendData);
    },

    editFun: function () {
      this.sendData.pages = []
      const pgn = this.pageno - 1;
      let createdpage = {};
      let repeatedfieldsavearray = {};
      createdpage.formId = this.saveid;
      createdpage.isArchived = true;
      createdpage.sourceID = this.iPaddress;
      createdpage.dataSource = "Web Browser";
      createdpage.pages = [];
      createdpage.pages[0] = {};
      createdpage.pages[0].pageName = this.htmlarray[0].pages[pgn].pageName;
      createdpage.pages[0].pageNo = this.htmlarray[0].pages[pgn].pageNo;
      createdpage.pages[0].pageStatus = this.htmlarray[0].pages[pgn].status;
      createdpage.pages[0].field = [];
      this.htmlarray[0].pages[pgn].field.forEach((subitem) => {
        let val;
        let itemstatus;
        if (subitem.type == 'checkbox') {
          val = (this.formdata[`pageNo${this.pageno}`][subitem.fieldName] != null) ? (this.formdata[`pageNo${this.pageno}`][subitem.fieldName].toString()) : "false";
          itemstatus = "Not Validated";
        }
        else if (subitem.type === 'RepeatingMeasure' || subitem.type === 'repeatingfield'
          || subitem.type === 'repeatedmeasure') {
          repeatedfieldsavearray[subitem.fieldName] = subitem.repeatingFields.map(repeatField => {
            return {
              fieldIdentifier: repeatField.fieldIdentifier,
              fields: repeatField.fields.map(data => {
                let value = this.formdata[`pageNo${this.pageno}`][subitem.fieldName][repeatField.fieldIdentifier][data.fieldName];
                if (data.type == 'checkbox') {
                  value = value ? value.toString() : "false"
                }
                if (data.type == 'scales') {
                  value = value ? value.toString() : ""
                }
                if (data.type == 'numberanddate' && this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier]) {
                  value = this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].datedata + "_" + this.repeatednumberanddateval[data.fieldName + repeatField.fieldIdentifier].numberdata;
                }
                if (data.type == 'dateandtime' && value) {
                  value = this.formatDateTime(value)
                }
                if (data.type == 'time' && value) {
                  value = this.convertTime(value)
                }
                if (this.visibility[data.fieldName + repeatField.fieldIdentifier] == "false" || this.visibility[data.fieldName + repeatField.fieldIdentifier] == false) {
                  val = "";
                }
                return {
                  ...data,
                  value: value,
                  visibility: this.getPayloadFieldVisibility(
                    data.fieldName,
                    repeatField.fieldIdentifier,
                    data.visibility
                  )
                };
              })
            };
          });
          this.isrepeatvalid[subitem.fieldName] = [];
          val = "";

        }
        else if (subitem.type == 'dateandtime') {
          val = this.formatDateTime(this.formdata[`pageNo${this.pageno}`][subitem.fieldName]);
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'date') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName];
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'time') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName] ? this.convertTime(this.formdata[`pageNo${this.pageno}`][subitem.fieldName]) : ""
          itemstatus = "Not Validated";
        }
        else if (subitem.type == 'scales') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName]
          if (val) {
            val = val.toString();
          }
          itemstatus = "";
        }

        else if (subitem.type == 'header' || subitem.type == 'subHeader') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName];
          itemstatus = "";
        }
        else if (subitem.type == 'numberanddate' && this.numberanddateval[subitem.fieldName]) {
          val = this.formatDateNum(this.numberanddateval[subitem.fieldName].datedata) + "_" + this.numberanddateval[subitem.fieldName].numberdata
          itemstatus = "";
        }
        else if (subitem.type == 'year') {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName]
          if (val) {
            val = val.toString();
          }
          itemstatus = "";
        }
        else {
          val = this.formdata[`pageNo${this.pageno}`][subitem.fieldName];
          itemstatus = "Not Validated";
        }
        if (subitem.visibility == "false" || subitem.visibility == false) {
          val = "";
        }
        createdpage.pages[0].field.push({
          fieldName: subitem.fieldName,
          label: subitem.label,
          type: subitem.type,
          value: val,
          status: itemstatus,
          validation: subitem.validation,
          groupOrderNo: subitem.groupOrderNo,
          limit: subitem.limit,
          validatedBy: "",
          validatedAt: "",
          comment: "",
          visibility: this.getPayloadFieldVisibility(subitem.fieldName, null, subitem.visibility),
          required: subitem.required,
          options: subitem.options,
          imagePath: subitem.imagePath,
          qrData: subitem.qrData,
          audit: [
            {
              oldValue: "",
              newValue: "",
              validatedBy: "",
              validatedDate: "",
              validatedTime: "",
              status: "Not validated",
              comment: "",
            },
          ],
          repeatingFieldData: repeatedfieldsavearray[subitem.fieldName]
        });
      });

      this.sendData.pages.push(createdpage.pages[0])

    },

    // save and edit ends

    nextfun: async function () {
      //isnextfunbtn
      if (this.isnextfunbtn) return;
      this.isnextfunbtn = true;
      try {
        if (this.permissions.includes('Add')) {
          if (this.requiredvalidate) {
            // Wait for validate() to finish before moving on
            await this.validate();
          }

          if (this.isvalid.length == 0) {
            let totalpg = parseInt(this.totalpages);
            if (this.pageno < totalpg) {
              if (this.issavefun) {
                if (this.pageno == 1 && this.nextPageClick == false) {
                  await this.savefun();
                  if (!(await this.commonvalidationfun(null, "invite-save"))) {
                    return;
                  }
                  this.saveid = await formService.apicall(this.sendData);
                  if (this.saveid != undefined || this.saveid != null) {
                    if (this.encodedFormList != undefined && this.requirednewform == true) {
                      await this.NewFormSave(false);
                    }
                  }
                  this.pageno++;
                  this.nextPageClick = true;
                } else {
                  this.editFun();
                  this.sendData.formId = this.saveid;
                  if (!(await this.commonvalidationfun(null, "invite-save"))) {
                    return;
                  }
                  await formService.editdata(this.sendData);
                  this.pageno++;
                }
              }
            }
          }
        }
        else {
          this.pageno++;
        }
      } finally {
        this.isnextfunbtn = false;
      }
    },
    previousFun: function () {
      if (this.pageno > 1) {
        console.log("previous page");
        this.pageno--;
      }
    },
    incrementcount: function () {
      this.totalpages++;
      console.log("increment" + this.totalpages);
    },
    onRadioChange(value, fieldName, pageNo) {
      console.clear();
      console.log("Radio button changed:", { value, fieldName, pageNo });

      if (fieldName === 'AEREL_CM') {
        if (value === 'Y') {
          if (!this.formdata[`pageNo${pageNo}`]['CMSEQ']) {
            this.formdata[`pageNo${pageNo}`]['CMSEQ'] = '';
          }
          this.getAeConMedFormData();
        } else {
          // Deselected: clear CMSEQ and reset lists
          this.formdata[`pageNo${pageNo}`]['CMSEQ'] = '';
          this.formList = [];
          this.LinkFieldList = [];
        }
      }
      else if (fieldName === 'CMAEREL') {
        if (value === 'Y') {
          if (!this.formdata[`pageNo${pageNo}`]['CMAENO']) {
            this.formdata[`pageNo${pageNo}`]['CMAENO'] = '';
          }
          this.getAeConMedFormData();
        } else {
          // Deselected: clear CMAENO and reset lists
          this.formdata[`pageNo${pageNo}`]['CMAENO'] = '';
          this.formList = [];
          this.LinkFieldList = [];
        }
      }
    },
    async getAeConMedFormData() {
      try {
        const idtoken = store.getters.getIdToken;
        const studyId = await store.getters.getStudyIs;
        const CrfTypeId = this.domain == "AE" ? "CM" : this.domain == "CM" ? "AE" : "";
        const response = await axios.get(
          `${this.baseurl}/forms/forms/listaeconmedforms?CrfTypeId=${CrfTypeId}&StudyId=${studyId}&SubjectId=${this.sendData.subjectId}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              'Content-Type': 'application/json',
            },
          }
        );
        this.formList = response.data;

        if (this.domain == "AE") {
          this.LinkFieldList = await this.getFieldValuesByName("CMTRT", "CMSEQ");
        }
        else if (this.domain == "CM") {
          this.LinkFieldList = await this.getFieldValuesByName("AETERM", "AESEQ");
        }
        console.log("Fetched link field list:", this.LinkFieldList);
      } catch (error) {
        console.error('Failed to fetch form list:', error);
        this.formList = [];
      }
    },
    async getFieldValuesByName(labelFieldName, valueFieldName) {
      const values = [];

      const forms = Array.isArray(this.formList)
        ? this.formList
        : this.formList?.entities;

      if (!Array.isArray(forms)) return values;

      for (const form of forms) {
        if (!Array.isArray(form.pages)) continue;

        for (const page of form.pages) {
          if (!Array.isArray(page.field)) continue;

          const labelField = page.field.find(f => f.fieldName === labelFieldName);
          const valueField = page.field.find(f => f.fieldName === valueFieldName);

          if (labelField && valueField) {
            values.push({
              label: labelField.value,
              value: valueField.value,
            });
          }
        }
      }

      return values;
    },
  },
  watch: {

    pageno(newpageno, oldpageno) {
      if (newpageno >= 1) {
        window.scrollTo(0, 0);
      }
    },
    autofillfromeconsent(newValue) {
      if (newValue) {
        this.getEConsentAutofillData(true);
      }
    },
    icfid(newValue, oldValue) {
      if (this.autofillfromeconsent && newValue !== oldValue) {
        this.getEConsentAutofillData(true);
      }
    }
  }
};
